export default {
  en: {
    translation: {
      Copied: "Copied",
      ackLink_1_1:
        "Each of the filled spot represents the contribution from our valuable donor. ",
      ackLink_1_2:
        "You are welcome to join them and help to fill up this image together. Please click",
      ackLink_2: "here",
      ackLink_3: ", for your kind support, thank you!",
      ackLink_link: "/../donate-now/",
      ackPageHeading: "Acknowledgement",
      ackTagline:
        "Thank you to our donors for their generous support to WestK",
      fbshareQuote:
        "I have donated to the fundraising initiatives of WestK. Come and join me to show your support to the development of arts and cultural in Hong Kong!",
      fbshareHash: "#WestKowloonCulturalDistrict",
      logoRedirectURL: "https://support-uat.westkowloon.hk/",
      invalidDonationAmount:
        "Donation amount cannot be empty.  Please enter the amount you wish to donate.",
      en: "EN",
      zhTW: "繁中",
      cn: "简中",
      hello: "Hello, {{user}}",
      alreadyLogin:
        "You are already login as {{user}}, do you want to proceed with the same identity?",
      user: "User",
      required: "Required.",
      requiredTerms: "Required to accept terms & conditions.",
      noneAvailable: "None Available",
      keywordSearch: "Keywords...",
      select: "Select",
      noItemsAvailable: "No such items available.",
      donationAmount: "Donation Amount",
      nameplaque: "Name Plaque",
      nameplaqueInfo: "Name Plaque Information",
      acknowledgementName: "Display Name",
      acknowledgementNameInfo: "Donation Information",
      personalInfo: "Personal Information",
      confirm: "Confirm",
      next: "Next",
      copyrightText0: "WestK and WestK logos are trademarks of West Kowloon Cultural District Authority.",
      copyrightText: "©2024 West Kowloon Cultural District Authority. All Rights Reserved.",
      confirmPay: "Confirm and Pay",
      displayName:
        "As a token of appreciation, your name may be published on the website of WKCD Foundation, please specify your preferred name in the below box:",
      //  "Your name will be shown in our webpage as a token of appreciation, for details, please refer to the below",
      thankYouSupport:
        "Thank you for your support! ('Anonymous' will be shown in your acknowledgement plaque)",
      anonymous: "Anonymous",
      leaveBlank:
        "If you wish to leave your donation as 'anonymous', please leave this field blank",
      dummyReference:
        "The below is dummy reference of your acknowledgment, please click here to see the actual page:",
      nameplaqueFootnote1:
        "The Acknowledgement Plaque will be displayed in the Park publicly.",
      nameplaqueFootnote2:
        "Please input a maximum of xx characters in Chinese / xx characters in English (including space) at the above field.",
      nameplaqueFootnote3: "Preview of Acknowledgement Plaque",
      nameplaqueFootnote4: "(Actual scaling may vary from the preview):",
      selectedItem: "Donation Information:",
      email: "Email",
      invalidEmail: "Email is invalid.",
      pleaseInputValidEmail: "Please input a valid email address.",
      password: "Password",
      loginFaster: "Log in for Faster Donation",
      existingAccount:
        "If you already have an WestK account, simply log in below.",
      incorrectPassword:
        'This email address is not registered or your password is incorrect. Please try again or register a new account. If you have forgotten your password, please click "Forgot Password?"',
      forgotPassword: "Forgot Password?",
      resetPasswordEmail:
        "We will send a reset password link to your registered email.",
      login: "Log In",
      logout: "LOGOUT",
      proceed: "PROCEED",
      yes: "YES",
      no: "NO",
      loginViaSalesforce: "Login",
      createAccount: "Create Account",
      createAnAccount: "Create an Account",
      createAccountNote_1: "Creating a ",
      createAccountNote_2:
        " account is simple and makes donation easier. All your information is safe and secure.",
      checkOut: "Donate",
      checkOutAsGuest: "Donate as a Guest",
      checkOutNote:
        "You can complete your donation without creating an account.",
      selectCreditCard: "Please select Credit Card type:",
      willRedirectToFirstData:
        "You will be linked to First Data payment page after selection of card type",
      followUs: "Follow us",
      Dr: "Dr.",
      Mr: "Mr.",
      Ms: "Ms.",
      Prof: "Prof.",
      Mrs: "Mrs.",

      //@TODO Removed NHR here.
      Nhr: "No honorific required",

      //@TODO Removed NHR here.
      "No honorific required": "No honorific required",

      Anonymous: "Anonymous",
      "Supported by": "Supported by",
      "In honour of": "In honour of",
      "In memory of": "In memory of",
      footnoteTimeout:
        "The above item will be reserved for you for 30 mins after confirmation of this page.",
      acknowledgementNameWillPlace:
        "You will be entitled to virtual acknowledgement for any donation HK$100 or above.",
      errorFailLockAsset:
        "Failed to pick your desired item. You will be redirected to homepage to choose another one.",
      generalProjectExpired:
        "Sorry, The Donation Project Item you selected had been Expired.",
      errorNameplate: "Included inappropriate language, please change.",

      errorBlockedName:
        "Failed to pick your desired item. Please input your acknowledgement name at the row above.",
      amountHKD: "Amount (HKD)",
      virtualPlaqueNote: "Virtual plaque will be displayed on our webpage",
      top: "Top",
      Map: "Map",
      List: "List",
      English: "English",
      Chinese: "Chinese",
      scientificName: "Scientific Name",
      PTN: {
        title: "POINTS TO NOTE:",
        ptnLine1:
          "The Foundation is a registered charity in Hong Kong; we will issue receipt for your tax deduction purpose for donation of HK$100 or above",
        ptnLine2:
          "The Foundation only accepts one-off payment in Hong Kong Dollar (HKD) at the time being. ",
        ptnLine3:
          "All donation to the Foundation are non-refundable and non-transferrable. ",
        ptnLine4:
          "All donation are inclusive of administrative costs including payment gateway fees.",
        ptnLine5:
          "Upon submission of donation form and successful payment, you will receive a confirmation email, and the e-version tax receipt will be received in 30 days. ",
        ptnLine6:
          "You represent and warrant that all the information you submit to us including without limitation name, contact number, email and credit card information, are true, correct, complete and up-to-date.",
        ptnLine7:
          "Our services may use or contain links to third-party services that are not owned or controlled by us including without limitation web developer, web hosting company and payment gateway provider. We assume no responsibility or liability, and this will be borne by the third-party services we use or have linkage.",
        ptnLine8:
          "We have the discretion to refuse the offer of donation for certain reasons including without limitation if the donation is dubious, if the donor does not comply with any directions or matters as stipulated in this donation form and if it is required by applicable law. ",
        ptnLine9:
          "The Foundation reserves the right of final decision on any dispute. ",
        ptnLineAsterisk:
          "* The Foundation is equivalent to the West Kowloon Cultural District Foundation Limited; WKCDA is equivalent to the West Kowloon Cultural District Authority; we or its grammatical variations is equivalent to the Foundation and WKCDA; and you or its grammatical variations is equivalent to the donor.",
        ptnLatestUpdateDate: "01/03/2021",
      },
      PICS: {
        picHTML: "<div class=''>" +
          "    <h2 class=''>Personal Information Collection Statement</h2>" +
          "    <div class=''>" +
          "      <p><strong>Collection of your personal data</strong></p>" +
          "<p>The West Kowloon Cultural District Authority (“<strong>WKCDA</strong>”) and its subsidiaries including but not limited to M Plus Museum Limited, Hong Kong Palace Museum Limited and West Kowloon Cultural District Foundation Limited (collectively called the “<strong>Group</strong>”, “<strong>us</strong>”, “<strong>our</strong>” or “<strong>we</strong>”) collect your personal data to provide our services to you and to improve customer experience. Please note that it is mandatory for you to provide personal data marked with asterisks. In the event that you do not provide such personal data, we may not be able to provide you with certain information, materials and/or your requested services.</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>Purposes of personal data collection and usage</strong></p>" +
          "<p>We will use your personal data for one or more of the following purposes:</p>" +
          "<ul><li>for processing your service requests (i.e. event registration, ticket purchase, e-newsletter subscription, product purchase, Wi-Fi usage, MyWestK account registration, member registration, venue booking, and donation, etc.) with us and providing you with our services;</li>" +
          "<li>for administering your membership account and maintaining your records;</li>" +
          "<li>for facilitating communications between you and us;</li>" +
          "<li>for notifying you of changes to our services that may affect you;</li>" +
          "<li>for responding to and following up on your enquiries;</li>" +
          "<li>for enhancing your experience in the West Kowloon Cultural District with programmes and offerings that are of interest;</li>" +
          "<li>for direct marketing upon obtaining explicit consent from you;</li>" +
          "<li>for managing customer relationships within the Group;</li>" +
          "<li>for communicating with you for potential support to the Group that is relevant to your interests and appropriate;</li>" +
          "<li>for conducting and facilitating promotional activities, events, lucky draws or prize redemption;</li>" +
          "<li>for customising and sending contents, advertisements, notifications and other information on our websites, mobile applications, social media platforms and other platforms (“platforms”) based on your habits, experience, interests and preferences;</li>" +
          "<li>for administering, maintaining and improving our platforms;</li>" +
          "<li>for conducting statistical analysis, research, surveys, quality assurance, behavioural analysis and review; and</li>" +
          "<li>for other purposes directly relating to any of the above.</li>" +
          "</ul><p>We may collect and combine/process information from you through various channels, such as online channels (e.g. websites, mobile applications, social media platforms), offline channels (e.g.&nbsp; physical application forms), or publicly available information about you. We use this information to help improve your experience and communicate with you about events and offerings that may be of interest.</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>Use of personal data</strong></p>" +
          "<p>The personal data collected will be used by and shared among the Group for purposes as stated above. We will never sell or rent your information with any other organisation outside the Group. We may transfer your personal information to our service providers such as IT contractors, cloud service providers, event agents and confidential documents disposal service agents, etc. in order for them to perform services on our behalf. We may also share your personal data with partners or service providers that are involved in co-organising events with us or providing goods and services to you or fulfilling your requests and may also transfer your personal data outside of Hong Kong for necessary handling, processing or storage. We will ask for your consent before sharing personal information with any third party partners for direct marketing purposes such as online platforms and social media platforms, etc. We require all service providers to respect the security of your personal data and comply with the Personal Data (Privacy) Ordinance (Cap. 486 of the laws of Hong Kong SAR) (the “<strong>Ordinance</strong>”) and other applicable personal data laws. We do not allow our service providers to use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with our instructions.</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>Location Information</strong></p>" +
          "<p>We use the location data described in this “Location Information” section to improve results in the App and for the purposes identified below.</p>" +
          "<p>" +
          "Users of the WestK App: if you've enabled your device's location services, we may collect and use your start location information when you open the App. If you disable your device's location services, we collect only the start and end points that you search manually. When you share your location in the WestK App, we collect your location information throughout your journey. We use this data to provide wayfinding support, such as providing a route to your destination.</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>Data access and correction requests</strong></p>" +
          "<p>You have the right to request access to and correction of your personal data held by the Group. Such request should be made in writing to the Data Protection Officer at <a href='mailto: privacy@wkcda.hk'>privacy@wkcda.hk</a> or by post/ in person to the address: West Kowloon Cultural District Authority, 9/F., WKCDA Tower, West Kowloon Cultural District, No. 8 Austin Road West, Kowloon, Hong Kong. For details of our privacy policy, you may refer to the Privacy Policy Statement at <a target='_blank' href='https://www.westk.hk/en/privacy'>https://www.westk.hk/en/privacy</a>.</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>Use of data in direct marketing</strong></p>" +
          "<p>We intend to use your personal data and/or share your personal data within the Group and with our partners including external online platforms and social media platforms for use in direct marketing, and we may not so use and/or share your personal data unless we have received your consent (which includes an indication of no objection to the intended use and/or sharing). Such direct marketing communications may take the form of mails, emails, SMSs, targeted online advertisements, notifications via our mobile applications, push notifications, instant messaging, etc. Such direct marketing communications may relate to products, activities, events and services of the Group, including those sponsored by or jointly organised by the Group with third parties, and those on offer or taking place at the West Kowloon Cultural District (“<strong>Marketing Communications</strong>”). Examples of these Marketing Communications include newsletters, membership benefits, shop/merchandise promotions, event invitations, invitations to donations, etc. These Marketing Communications may be sent by the Group and/or an external party on our behalf (e.g. external online platforms and social media platforms). Please indicate your consent or no objection for such use and/or sharing in the relevant online or offline forms at the time of collection of your information.</p>" +
          "<p>If you do not wish to receive the aforementioned Marketing Communications, you may choose to opt-out from direct marketing at any time, free of charge, by:</p>" +
          "<ul><li>clicking the “Unsubscribe” link at the bottom of our emails;</li>" +
          "<li>emailing us at&nbsp;<a href='mailto:unsubscribe @wkcda.hk'>unsubscribe@wkcda.hk</a>; or</li>" +
          "<li>contacting our Data Protection Officer by post to ‘West Kowloon Cultural District Authority, 9/F., WKCDA Tower, West Kowloon Cultural District, No. 8 Austin Road West, Kowloon, Hong Kong’.</li>" +
          "</ul><p>If you do not wish to receive information particularly in relation to fundraising activities (including promotion of donations or contributions for charitable or non-profit making events of the Group), you may choose to opt-out from fundraising activities at any time, free of charge, by emailing us at&nbsp;<a href='mailto:development@wkcda.hk'>development@wkcda.hk</a>.</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>Language versions</strong></p>" +
          "<p>In case of discrepancies between the English and Chinese versions of this Statement, the English version shall apply and prevail.</p>" +
          "" +
          "    </div>" +
          "  </div>",

        title: "PERSONAL INFORMATION COLLECTION STATEMENT:",
        CollectionOfYourPersonalData_title: "Collection of your personal data",
        CollectionOfYourPersonalData_text:
          "The West Kowloon Cultural District Authority and all its subsidiaries including West Kowloon Cultural District Foundation Limited (the “Foundation”) (collectively the “Group” or “we”) collect your personal data to provide our services to you and to improve your experience. Please note that it is mandatory for you to provide personal data marked with asterisks. In the event that you do not provide such personal data, we may not be able to provide you with certain information, materials, and/or your requested services in relation to your donation or proceed with your donation.",

        PurposesOfPersonalDataCollectionAndUsage_title:
          "Purposes of personal data collection and usage",
        PurposesOfPersonalDataCollectionAndUsage_line_1:
          "We will use your personal data collected for one or more of the following purposes:",
        PurposesOfPersonalDataCollectionAndUsage_point_1:
          "for updating your acknowledgement, stewarding your donation, and keeping you informed of the impact of your giving, in a professional and respectful manner;",
        PurposesOfPersonalDataCollectionAndUsage_point_2:
          "for processing your service requests (e.g. donation, tax receipt, gift acknowledgement, donation confirmation, event registration, e-newsletter subscription etc.) with us and provide you with the services;",
        PurposesOfPersonalDataCollectionAndUsage_point_3:
          "for facilitating communications between you and members of the Group in respect of your service requests; ",
        PurposesOfPersonalDataCollectionAndUsage_point_4:
          "for personalising your experience in the West Kowloon Cultural District with programmes and offerings that are most relevant to your interests; ",
        PurposesOfPersonalDataCollectionAndUsage_point_5:
          "for notifying you of changes to our services that may affect you;",
        PurposesOfPersonalDataCollectionAndUsage_point_6:
          "for responding to and follow up on your enquiries; ",
        PurposesOfPersonalDataCollectionAndUsage_point_7:
          "for conducting statistical analysis, research, surveys, quality assurance and review; and",

        PurposesOfPersonalDataCollectionAndUsage_line_2:
          "If you give your consent for direct marketing: -",
        PurposesOfPersonalDataCollectionAndUsage_point_8:
          "for communicating with you on our events, services, promotions, special offers and development updates (include fundraising campaigns and sponsorships); ",
        PurposesOfPersonalDataCollectionAndUsage_point_9:
          "for communicating with you for potential support / financial support to us that is relevant to your interests and appropriate; and ",
        PurposesOfPersonalDataCollectionAndUsage_point_10:
          "for other purposes directly relating to any of the above. ",

        PurposesOfPersonalDataCollectionAndUsage_line_3:
          "We will combine information you provide to us through various channels, such as online channels like websites / mobile applications, offline channels like physical application forms, or publicly available information about you. We use this combined information to help personalise your experience and communicate with you about events and offerings that may be of particular interest to you.",

        TransferOfPersonalData_title: "Transfer of personal data",
        TransferOfPersonalData_line_1:
          "The personal data collected will be used only for purposes as stated above. We will never sell, rent or exchange your details with any other organisation outside the Group. We will ask for your consent to share personal information with third parties. Some of our service providers will have access to your data in order to perform services on our behalf. We require all service providers to respect the security of your personal data and comply with the the Personal Data (Privacy) Ordinance (Cap. 486 of the laws of Hong Kong SAR) (“the Ordinance”). We do not allow our service providers to use your personal data for their own purposes and only permit them to process your personal data for specified purposes and in accordance with our instructions.",

        TransferOfPersonalDataOutsideHongKong_title:
          "Transfer of personal data outside Hong Kong",
        TransferOfPersonalDataOutsideHongKong_text_1:
          "Please also note that your personal data transferred to us may or may not be located within Hong Kong, and your information may be subjected to cross-border transfer to places outside Hong Kong for necessary handling, processing or storage.",

        PersonalDataSecurityAndRetentionOfData_title:
          "Personal data security and retention of data",
        PersonalDataSecurityAndRetentionOfData_text_1:
          "Please note that your personal data will not be kept longer than necessary in accordance with the Ordinance and that we will comply with all statutory and regulatory requirements in the Hong Kong SAR concerning the retention of personal data. Your personal data stored will be accessed only by our employees or service providers who are authorised to do so.",

        Personaldatasecurityandretentionofdatatitle:
          "Data access and correction requests",
        Personaldatasecurityandretentionofdatatext_1:
          'You have the right to request access to and correction of your personal data held by the Group. Such request should be made in writing to the Data Protection Officer at <a href="mailto:privacy@wkcda.hk">privacy@wkcda.hk</a> or by post to the address: “West Kowloon Cultural District Authority, 9/F., WKCDA Tower, West Kowloon Cultural District, No. 8 Austin Road West, Kowloon, Hong Kong”. For details of our privacy policy, you may refer to the Privacy Policy at <a href="http://www.westkowloon.hk/en/footer/privacy-policy">http://www.westkowloon.hk/en/footer/privacy-policy</a>.',

        UseOfDataInDirectMarketing_title: "Use of data in direct marketing",
        UseOfDataInDirectMarketing_text_1:
          "We intend to use your personal data in direct marketing, and we may not use your personal data unless we have received your consent (which includes an indication of no objection to the intended use).",
        UseOfDataInDirectMarketing_text_2:
          "We may use your name, contact details (such as email address), preferences and interests, profile information, transaction data for providing you with information that are most relevant to your interests on development updates, philanthropic interests, events, services, promotions and special offers at the West Kowloon Cultural District and/or provided by the Group, and ways to support the Group. Please TICK THE APPROPRIATE BOX(ES) in the “Declaration and Consent” section of the Donation Form if you do not agree to such use.",

        UseOfDataInDirectMarketing_text_3:
          "If you do not wish to receive information from the Group for the aforementioned direct marketing purposes, you may choose to opt-out from direct marketing at any time, free of charge, by:",
        UseOfDataInDirectMarketing_point_1:
          "clicking the “Unsubscribe” link at the bottom of our emails; ",
        UseOfDataInDirectMarketing_point_2:
          'emailing us at <a href="mailto:unsubscribe@wkcda.hk">unsubscribe@wkcda.hk</a>; or',
        UseOfDataInDirectMarketing_point_3:
          "contacting our Data Protection Officer by post to “West Kowloon Cultural District Authority, 9/F., WKCDA Tower, West Kowloon Cultural District, No. 8 Austin Road West, Kowloon, Hong Kong”.",

        UseOfDataInDirectMarketing_text_4:
          'If you do not wish to receive information in particular relevant to fundraising activities (including promotion of donation or contributions for charitable or non-profit making events), you may choose to opt-out from fundraising activities at any time, free of charge, by emailing us at <a href="mailto:development@wkcda.hk">development@wkcda.hk</a>. ',

        LanguageVersions_title: "Language versions",
        LanguageVersions_line_1:
          "In case of discrepancies between the English and Chinese versions of this Statement, the English version shall apply and prevail.",
        picsLatestUpdateDate: "01/03/2021",
      },
      form: {
        personalInfo: "Personal Information",
        mustInput:
          "Please complete all the below mandatory fields marked with * ",
        title: "Title*",
        firstName: "First Name*",
        lastName: "Last Name*",
        taxDeductibleNote: "Name to be printed on tax-deductible receipt",
        overrideWestkowloonAccounts:
          "Agree to override my personal information (ie. name & tel) provided earlier by the above latest update",
        phone: "Phone/Mobile*",
        phoneLengthRequired:
          "Phone number must be in {{length}}-digit or above.",
        areaCode: "Area Code",
        venuesHeader: "Venue(s) you are interested at",
        languagePref: "Your language preference*",
        receipt: "Receipt",
        receiptNote:
          "E-receipt will be issued for your record, please ensure the above email being provided is correct. Should you need a printed-version, please check the below box and provide your postal address accordingly. The printed receipt will be sent within 1 month.",
        receiptNote_pa: "An e-receipt will be issued for your record.",
        receiptCheckboxNote:
          "Please check this box and provide us your mailing address in the below",
        receiptCheckboxNote_pa:
          "Should you need a printed-version of the receipt, please tick the box. The printed receipt will be sent within 1 month.",
        PICHeader: "Personal Information Collection Statement",
        PICaria: "I hereby declare that I have read in details",
        PICStatement1:
          "I hereby declare that I have read in details, fully understand and agree to be bounded by",
        termsAndConditions: " points to note ",
        and: " and ",
        PICS: "Personal Information Collection Statement (PICS)",
        PICStatement2:
          " of West Kowloon Cultural District Foundation Limited. I consent to West Kowloon Cultural District Foundation Limited using my personal data and understand that I can request for access and correction of my personal data, all as described in PICS.",
        dataUseMarketing: "Use of data in direct marketing",
        marketingPurpose:
          "We intend to use your name, contact details (such as email address), preferences and interests, profile information, transaction data for providing you with information that are most relevant to your interests on events, services, promotions and special offers at the West Kowloon Cultural District, and ways to support the Group.",
        eNewsNotification:
          "*If you have already subscribed to our e-Newsletter, you can unsubscribe at any time using the links at the bottom of our e-newsletters.",
        checkboxReceiveInfo:
          "I wish to receive information about activities and events organized by or taking place at West Kowloon Cultural District.",
        checkboxReceiveDevUpdates: "I wish to receive development updates.",
        revise: "Back",
        addressLine1: "Address Line 1",
        addressLine2: "Address Line 2",
        roomFloorBlock: "Room／Floor／Block",
        buildingEstateStreet: "Building／ Estate / Street",
        region: "Region",
        district: "District",
        area: "Area",
        hongKong: "Hong Kong SAR",
        termsAndConditionsURL:
          "https://www.westkowloon.hk/en/footer/privacy-policy#pps",
        PICSURL: "https://www.westkowloon.hk/en/footer/privacy-policy#pps",
      },
      venue: {
        "WKCDA General": "WestK General",
        artPark: "Art Park",
        palaceMuseum: "Hong Kong Palace Museum",
        mPlus: "M+",
        xiquCentre: "Xiqu Centre",
        lyricThreatre: "Lyric Theatre Complex",
        freespace: "Freespace",
        "West Kowloon in General":
          "WestK in General",
        "Art Park": "Art Park",
        "Hong Kong Palace Museum": "Hong Kong Palace Museum",
        "M+": "M+",
        "Xiqu Centre": "Xiqu Centre",
        "Lyric Theatre Complex": "Lyric Theatre Complex",
        Freespace: "Freespace",
      },
      filter: {
        showDonorsNearby: "Show donors nearby",
        tree: "Adopt a Tree",
        bench: "Sponsor a Bench",
        seat: "Pick a Seat",
        price: "Price",
        woodland: "Inner Park",
        seaside: "Seaside",
        // "urbanForest": "Urban Forest",
        // "orchard": "Orchard",
        reset: "Reset Filter",
      },
      success: {
        title_thankyou: "Thank you",
        title_fail: "You're almost there",

        thankYou:
          "Thank you for your donation to WestK.",
        thankYou2:
          "Your receipt will be ready within 1 month once the donation is confirmed.",
        thankYou3:
          "Your support will allow us to provide exceptional performances, programmes and exhibitions  and make arts and culture accessible to everyone.",
        thankYou4:
          "Should you have any queries regarding your donation, please reach out to us at <a href='mailto:donation@wkcda.hk'>donation@wkcda.hk</a>.",

        donationReceived:
          "Your donation has been well received and the following details have been captured under the review process:",
        fail: "You are just one step away from completing your donation. Please make sure all the information you have provided are correct or check with your bank.",
        failLine2:
          "Your donation can make a difference to WestK. We look forward to receiving your support!",
        failLine3: "",
        failLine4:
          "Should you have any queries, please contact us at <a href='mailto:donation@wkcda.hk'>donation@wkcda.hk</a>",

        amount: "Your donation amount: {{price}}",
        donationAcknowledgement:
          "Your donation acknowledgement will be shown as: {{acknowledgement}}",
        receiptName: "Name on your official receipt: {{name}}",
        ref: "Donation Ref: {{donationId}}",
        type: "Type of Donation: {{projectType}}",
        assetName: "Asset Name: {{assetName}}",
        message: "Message: {{message}}",
        taxReceipt:
          "A tax receipt will be ready for you once the donation is confirmed in 30 days and the related acknowledgement publicity material will be shared with you.",
        contactYou:
          "We might contact you in the meantime for suggested naming (if needed) or other related issues.",
        reachUsAt: `On behalf of everyone at WestK, artistic talents from the local and international art community and the millions of art lovers from Hong Kong and around the world -
          thank you! Should you have any queries regarding your donation, please reach us at donation@wkcda.hk`,
        donateAgain: "Make another donation",
        backWestKowloon: "Back to Foundation homepage",
        donateAgainURLG: "https://support-uat.westkowloon.hk/donate-now/",
        donateAgainURLA: "https://support-uat.westkowloon.hk/donation/?lng=en",
        backWestKowloonURL: "https://support-uat.westkowloon.hk/",
      },
      cookies: {
        cookies_experience:
          "We use cookies on this site to enhance your user experience.",
        more_info: "More info",
        agree: "Agree",
      },
      notFound: {
        notExist: "This page is not exist",
        backHome: "Back Home",
        uri: "https://support-uat.westkowloon.hk/",
      },
      "Hong Kong SAR": "Hong Kong SAR",
      China: "China",
      "Macau SAR": "Macau SAR",
      Afghanistan: "Afghanistan",
      Albania: "Albania",
      Algeria: "Algeria",
      "American Samoa": "American Samoa",
      Andorra: "Andorra",
      Angola: "Angola",
      Anguilla: "Anguilla",
      Antarctica: "Antarctica",
      "Antigua and Barbuda": "Antigua and Barbuda",
      Argentina: "Argentina",
      Armenia: "Armenia",
      Aruba: "Aruba",
      Australia: "Australia",
      Austria: "Austria",
      Azerbaijan: "Azerbaijan",
      Bahamas: "Bahamas",
      Bahrain: "Bahrain",
      Bangladesh: "Bangladesh",
      Barbados: "Barbados",
      Belarus: "Belarus",
      Belgium: "Belgium",
      Belize: "Belize",
      Benin: "Benin",
      Bermuda: "Bermuda",
      Bhutan: "Bhutan",
      Bolivia: "Bolivia",
      "Bonaire, Sint Eustatius and Saba": "Bonaire, Sint Eustatius and Saba",
      "Bosnia and Herzegovina": "Bosnia and Herzegovina",
      Botswana: "Botswana",
      "Bouvet Island": "Bouvet Island",
      Brazil: "Brazil",
      "British Indian Ocean Territory": "British Indian Ocean Territory",
      Brunei: "Brunei",
      Bulgaria: "Bulgaria",
      "Burkina Faso": "Burkina Faso",
      Burundi: "Burundi",
      Cambodia: "Cambodia",
      Cameroon: "Cameroon",
      Canada: "Canada",
      "Cape Verde": "Cape Verde",
      "Cayman Islands": "Cayman Islands",
      "Central African Republic": "Central African Republic",
      Chad: "Chad",
      Chile: "Chile",
      "Christmas Island": "Christmas Island",
      "Cocos (Keeling) Islands": "Cocos (Keeling) Islands",
      Colombia: "Colombia",
      Comoros: "Comoros",
      "Congo, Democratic Republic of the": "Democratic Republic of the Congo",
      "Congo, Republic of the": "Republic of the Congo",
      "Cook Islands": "Cook Islands",
      "Costa Rica": "Costa Rica",
      "Cote d'Ivoire": "Cote d'Ivoire",
      Croatia: "Croatia",
      Cuba: "Cuba",
      Curacao: "Curacao",
      Cyprus: "Cyprus",
      "Czech Republic": "Czech Republic",
      Denmark: "Denmark",
      Djibouti: "Djibouti",
      Dominica: "Dominica",
      "Dominican Republic": "Dominican Republic",
      Ecuador: "Ecuador",
      Egypt: "Egypt",
      "El Salvador": "El Salvador",
      "Equatorial Guinea": "Equatorial Guinea",
      Eritrea: "Eritrea",
      Estonia: "Estonia",
      Ethiopia: "Ethiopia",
      "Falkland Islands (Islas Malvinas)": "Falkland Islands (Islas Malvinas)",
      "Faroe Islands": "Faroe Islands",
      Fiji: "Fiji",
      Finland: "Finland",
      France: "France",
      "French Guiana": "French Guiana",
      "French Polynesia": "French Polynesia",
      "French Southern and Antarctic Lands": "法國南部和南極土地",
      Gabon: "Gabon",
      Gambia: "Gambia",
      Georgia: "Georgia",
      Germany: "Germany",
      Ghana: "Ghana",
      Gibraltar: "Gibraltar",
      Greece: "Greece",
      Greenland: "Greenland",
      Grenada: "Grenada",
      Guadeloupe: "Guadeloupe",
      Guam: "Guam",
      Guatemala: "Guatemala",
      Guernsey: "Guernsey",
      Guinea: "Guinea",
      "Guinea-Bissau": "Guinea-Bissau",
      Guyana: "Guyana",
      Haiti: "Haiti",
      "Heard Island and McDonald Islands": "Heard Island and McDonald Islands",
      "Holy See (Vatican City)": "Holy See (Vatican City)",
      Honduras: "Honduras",
      Hungary: "Hungary",
      Iceland: "Iceland",
      India: "India",
      Indonesia: "Indonesia",
      Iran: "Iran",
      Iraq: "Iraq",
      Ireland: "Ireland",
      "Isle of Man": "Isle of Man",
      Israel: "Israel",
      Italy: "Italy",
      Jamaica: "Jamaica",
      Japan: "Japan",
      Jersey: "Jersey",
      Jordan: "Jordan",
      Kazakhstan: "Kazakhstan",
      Kenya: "Kenya",
      Kiribati: "Kiribati",
      "Korea, North": "Korea, North",
      "Korea, South": "Korea, South",
      Kosovo: "Kosovo",
      Kuwait: "Kuwait",
      Kyrgyzstan: "Kyrgyzstan",
      Laos: "Laos",
      Latvia: "Latvia",
      Lebanon: "Lebanon",
      Lesotho: "Lesotho",
      Liberia: "Liberia",
      Libya: "Libya",
      Liechtenstein: "Liechtenstein",
      Lithuania: "Lithuania",
      Luxembourg: "Luxembourg",
      Macedonia: "Macedonia",
      Madagascar: "Madagascar",
      Malawi: "Malawi",
      Malaysia: "Malaysia",
      Maldives: "Maldives",
      Mali: "Mali",
      Malta: "Malta",
      "Marshall Islands": "Marshall Islands",
      Martinique: "Martinique",
      Mauritania: "Mauritania",
      Mauritius: "Mauritius",
      Mayotte: "Mayotte",
      Mexico: "Mexico",
      Micronesia: "Micronesia",
      Moldova: "Moldova",
      Monaco: "Monaco",
      Mongolia: "Mongolia",
      Montenegro: "Montenegro",
      Montserrat: "Montserrat",
      Morocco: "Morocco",
      Mozambique: "Mozambique",
      Myanmar: "Myanmar",
      Namibia: "Namibia",
      Nauru: "Nauru",
      Nepal: "Nepal",
      Netherlands: "Netherlands",
      "New Caledonia": "New Caledonia",
      "New Zealand": "New Zealand",
      Nicaragua: "Nicaragua",
      Niger: "Niger",
      Nigeria: "Nigeria",
      Niue: "Niue",
      "Norfolk Island": "Norfolk Island",
      "Northern Mariana Islands": "Northern Mariana Islands",
      Norway: "Norway",
      Oman: "Oman",
      Pakistan: "Pakistan",
      Palau: "Palau",
      Panama: "Panama",
      "Papua New Guinea": "Papua New Guinea",
      Paraguay: "Paraguay",
      Peru: "Peru",
      Philippines: "Philippines",
      "Pitcairn Islands": "Pitcairn Islands",
      Poland: "Poland",
      Portugal: "Portugal",
      "Puerto Rico": "Puerto Rico",
      Qatar: "Qatar",
      Reunion: "Reunion",
      Romania: "Romania",
      Russia: "Russia",
      Rwanda: "Rwanda",
      "Saint Barthelemy": "Saint Barthelemy",
      "Saint Helena, Ascension, and Tristan da Cunha":
        "Saint Helena, Ascension, and Tristan da Cunha",
      "Saint Kitts and Nevis": "Saint Kitts and Nevis",
      "Saint Lucia": "Saint Lucia",
      "Saint Martin": "Saint Martin",
      "Saint Pierre and Miquelon": "Saint Pierre and Miquelon",
      "Saint Vincent and the Grenadines": "Saint Vincent and the Grenadines",
      Samoa: "Samoa",
      "San Marino": "San Marino",
      "Sao Tome and Principe": "Sao Tome and Principe",
      "Saudi Arabia": "Saudi Arabia",
      Senegal: "Senegal",
      Serbia: "Serbia",
      Seychelles: "Seychelles",
      "Sierra Leone": "Sierra Leone",
      Singapore: "Singapore",
      "Sint Maarten": "Sint Maarten",
      Slovakia: "Slovakia",
      Slovenia: "Slovenia",
      "Solomon Islands": "Solomon Islands",
      Somalia: "Somalia",
      "South Africa": "South Africa",
      "South Georgia and the Islands": "South Georgia and the Islands",
      "South Sudan": "South Sudan",
      Spain: "Spain",
      "Sri Lanka": "Sri Lanka",
      "State of Palestine": "State of Palestine",
      Sudan: "Sudan",
      Suriname: "Suriname",
      Svalbard: "Svalbard",
      Swaziland: "Swaziland",
      Sweden: "Sweden",
      Switzerland: "Switzerland",
      Syria: "Syria",
      Taiwan: "Taiwan",
      Tajikistan: "Tajikistan",
      Tanzania: "Tanzania",
      Thailand: "Thailand",
      Timor: "東帝汶",
      Togo: "Togo",
      Tokelau: "Tokelau",
      Tonga: "Tonga",
      "Trinidad and Tobago": "Trinidad and Tobago",
      Tunisia: "Tunisia",
      Turkey: "Turkey",
      Turkmenistan: "Turkmenistan",
      "Turks and Caicos Islands": "Turks and Caicos Islands",
      Tuvalu: "Tuvalu",
      Uganda: "Uganda",
      Ukraine: "Ukraine",
      "United Arab Emirates": "United Arab Emirates",
      "United Kingdom": "United Kingdom",
      "United States": "United States",
      "United States Minor Outlying Islands":
        "United States Minor Outlying Islands",
      Uruguay: "Uruguay",
      Uzbekistan: "Uzbekistan",
      Vanuatu: "Vanuatu",
      Venezuela: "Venezuela",
      Vietnam: "Vietnam",
      "Virgin Islands (British)": "Virgin Islands (British)",
      "Virgin Islands (U.S.)": "Virgin Islands (U.S.)",
      "Virgin Islands (US.)": "Virgin Islands (U.S.)",
      "Wallis and Futuna": "Wallis and Futuna",
      "Western Sahara": "Western Sahara",
      Yemen: "Yemen",
      Zambia: "Zambia",
      Zimbabwe: "Zimbabwe",
      "Åland Islands": "Åland Islands",
      "Hong Kong Island": "Hong Kong Island",
      Kowloon: "Kowloon",
      "New Territories": "New Territories",
      "Central and Western": "Central and Western",
      Eastern: "Eastern",
      Southern: "Southern",
      "Wan Chai": "Wan Chai",
      "Kowloon City": "Kowloon City",
      "Kwun Tong": "Kwun Tong",
      "Sham Shui Po": "Sham Shui Po",
      "Wong Tai Sin": "Wong Tai Sin",
      "Yau Tsim Mong": "Yau Tsim Mong",
      Islands: "Islands",
      "Kwai Tsing": "Kwai Tsing",
      North: "North",
      "Sai Kung": "Sai Kung",
      "Sha Tin": "Sha Tin",
      "Tai Po": "Tai Po",
      "Tsuen Wan": "Tsuen Wan",
      "Tuen Mun": "Tuen Mun",
      "Yuen Long": "Yuen Long",
      "Kennedy Town": "Kennedy Town",
      "Shek Tong Tsui": "Shek Tong Tsui",
      "Sai Ying Pun": "Sai Ying Pun",
      "Sheung Wan": "Sheung Wan",
      Central: "Central",
      Admiralty: "Admiralty",
      "Mid-levels": "Mid-levels",
      Peak: "Peak",
      "Tin Hau": "Tin Hau",
      "Braemar Hill": "Braemar Hill",
      "North Point": "North Point",
      "Quarry Bay": "Quarry Bay",
      "Sai Wan Ho": "Sai Wan Ho",
      "Shau Kei Wan": "Shau Kei Wan",
      "Chai Wan": "Chai Wan",
      "Siu Sai Wan": "Siu Sai Wan",
      "Pok Fu Lam": "Pok Fu Lam",
      Aberdeen: "Aberdeen",
      "Ap Lei Chau": "Ap Lei Chau",
      "Wong Chuk Hang": "Wong Chuk Hang",
      "Shouson Hill": "Shouson Hill",
      "Repulse Bay": "Repulse Bay",
      "Chung Hom Kok": "Chung Hom Kok",
      Stanley: "Stanley",
      "Tai Tam": "Tai Tam",
      "Shek O": "Shek O",
      "Wan Chai": "Wan Chai",
      "Causeway Bay": "Causeway Bay",
      "Happy Valley": "Happy Valley",
      "Tai Hang": "Tai Hang",
      "So Kon Po": "So Kon Po",
      "Jardine's Lookout": "Jardine's Lookout",
      "Hung Hom": "Hung Hom",
      "To Kwa Wan": "To Kwa Wan",
      "Ma Tau Kok": "Ma Tau Kok",
      "Ma Tau Wai": "Ma Tau Wai",
      "Kai Tak": "Kai Tak",
      "Kowloon City": "Kowloon City",
      "Ho Man Tin": "Ho Man Tin",
      "Kowloon Tong": "Kowloon Tong",
      "Beacon Hill": "Beacon Hill",
      "Ping Shek": "Ping Shek",
      "Kowloon Bay": "Kowloon Bay",
      "Ngau Tau Kok": "Ngau Tau Kok",
      "Jordan Valley": "Jordan Valley",
      "Kwun Tong": "Kwun Tong",
      "Sau Mau Ping": "Sau Mau Ping",
      "Lam Tin": "Lam Tin",
      "Yau Tong": "Yau Tong",
      "Lei Yue Mun": "Lei Yue Mun",
      "Mei Foo": "Mei Foo",
      "Lai Chi Kok": "Lai Chi Kok",
      "Cheung Sha Wan": "Cheung Sha Wan",
      "Sham Shui Po": "Sham Shui Po",
      "Shek Kip Mei": "Shek Kip Mei",
      "Yau Yat Tsuen": "Yau Yat Tsuen",
      "Tai Wo Ping": "Tai Wo Ping",
      "Stonecutters Island": "Stonecutters Island",

      "San Po Kong": "San Po Kong",
      "Wong Tai Sin": "Wong Tai Sin",
      "Tung Tau": "Tung Tau",
      "Wang Tau Hom": "Wang Tau Hom",
      "Lok Fu": "Lok Fu",
      "Diamond Hill": "Diamond Hill",
      "Tsz Wan Shan": "Tsz Wan Shan",
      "Ngau Chi Wan": "Ngau Chi Wan",
      "Tsim Sha Tsui": "Tsim Sha Tsui",
      "Yau Ma Tei": "Yau Ma Tei",
      "West Kowloon Reclamation": "West Kowloon Reclamation",
      "King's Park": "King's Park",
      "Mong Kok": "Mong Kok",
      "Tai Kok Tsui": "Tai Kok Tsui",

      "Cheung Chau": "Cheung Chau",
      "Peng Chau": "Peng Chau",
      "Lantau Island (incl. Tung Chung)": "Lantau Island (incl. Tung Chung)",
      "Lantau Island (incl Tung Chung)": "Lantau Island (incl. Tung Chung)",
      "Lamma Island": "Lamma Island",
      "Kwai Chung": "Kwai Chung",
      "Tsing Yi": "Tsing Yi",

      Fanling: "Fanling",
      "Luen Wo Hui": "Luen Wo Hui",
      "Sheung Shui": "Sheung Shui",
      "Shek Wu Hui": "Shek Wu Hui",
      "Sha Tau Kok": "Sha Tau Kok",
      "Luk Keng": "Luk Keng",
      "Wu Kau Tang": "Wu Kau Tang",
      "Clear Water Bay": "Clear Water Bay",
      "Sai Kung": "Sai Kung",
      "Tai Mong Tsai": "Tai Mong Tsai",
      "Tseung Kwan O": "Tseung Kwan O",
      "Hang Hau": "Hang Hau",
      "Tiu Keng Leng": "Tiu Keng Leng",
      "Ma Yau Tong": "Ma Yau Tong",
      "Tai Wai": "Tai Wai",
      "Sha Tin": "Sha Tin",
      "Fo Tan": "Fo Tan",
      "Ma Liu Shui": "Ma Liu Shui",
      "Wu Kai Sha": "Wu Kai Sha",
      "Ma On Shan": "Ma On Shan",
      "Tai Po Market": "Tai Po Market",
      "Tai Po": "Tai Po",
      "Tai Po Kau": "Tai Po Kau",
      "Tai Mei Tuk": "Tai Mei Tuk",
      "Shuen Wan": "Shuen Wan",
      "Cheung Muk Tau": "Cheung Muk Tau",
      "Kei Ling Ha": "Kei Ling Ha",
      "Tsuen Wan": "Tsuen Wan",
      "Lei Muk Shue": "Lei Muk Shue",
      "Ting Kau": "Ting Kau",
      "Sham Tseng": "Sham Tseng",
      "Tsing Lung Tau": "Tsing Lung Tau",
      "Ma Wan": "Ma Wan",
      "Sunny Bay": "Sunny Bay",
      "Tai Lam Chung": "Tai Lam Chung",
      "So Kwun Wat": "So Kwun Wat",
      "Tuen Mun": "Tuen Mun",
      "Lam Tei": "Lam Tei",
      "Hung Shui Kiu": "Hung Shui Kiu",
      "Ha Tsuen": "Ha Tsuen",
      "Lau Fau Shan": "Lau Fau Shan",
      "Tin Shui Wai": "Tin Shui Wai",
      "Yuen Long": "Yuen Long",
      "San Tin": "San Tin",
      "Lok Ma Chau": "Lok Ma Chau",
      "Kam Tin": "Kam Tin",
      "Shek Kong": "Shek Kong",
      "Pat Heung": "Pat Heung",
    },
  },
  zhTW: {
    translation: {
      Copied: "已複製",
      ackLink_1_1: "以上每個填滿的圓點均代表我們寶貴的捐助者之貢獻。",
      ackLink_1_2: "你也可以加入他們的行列，攜手填滿上圖。 歡迎你的支持：",
      ackLink_2: "請按此",
      ackLink_3: "，感謝！",
      ackLink_link: "/../tc/donate-now-hk/",

      ackPageHeading: "鳴謝",
      ackTagline: "感謝以下支持者對我們慷慨的捐助",

      fbshareQuote:
        "我捐款支持了西九文化區的籌款活動！歡迎加入我的行列，以表示對香港藝術和文化發展的支持！",
      fbshareHash: "#西九文化區",

      logoRedirectURL: "https://support-uat.westkowloon.hk/tc/home-hk/",
      invalidDonationAmount: "捐款金額不能留空。 請輸入捐贈的金額。",
      en: "EN",
      zhTW: "繁中",
      cn: "简中",
      hello: "{{user}}，你好！",
      alreadyLogin: "閣下已經以{{user}}身份登入，是否以相同身份繼續？",
      user: "用戶",
      required: "必需。",
      requiredTerms: "必需接受條款和條件。",
      noneAvailable: "沒有",
      keywordSearch: "搜尋...",
      select: "確認",
      noItemsAvailable: "沒有這樣的物品。",
      donationAmount: "捐款金額",
      nameplaque: "感謝牌",
      nameplaqueInfo: "感謝牌資料",
      acknowledgementName: "顯示名稱",
      acknowledgementNameInfo: "捐款資料",
      personalInfo: "個人資料",
      confirm: "確認",
      next: "下一步",
      copyrightText0: "WestK及WestK標誌均為西九文化區管理局的商標。",
      copyrightText: "©2024 西九文化區管理局。保留所有權利。 ",
      confirmPay: "確認及付款",
      //     displayName: "閣下的名字將會顯示在本網頁以示感謝, 請參見下列之示意圖",
      thankYouSupport: "感謝你的支持！（閣下的感謝牌將會顯示為：無名氏）",
      displayName:
        "為表示感謝，閣下的名字或會在西九文化基金會的網站發布，請在以下位置填寫你指定之名字：",
      //“您的姓名將在我們的網頁上顯示，以表示感謝，有關詳細信息，請參閱以下內容”，

      anonymous: "無名氏",
      leaveBlank: "閣下如想以匿名捐贈, 請將此欄目留空。",
      dummyReference: "以下為感謝頁面示意圖，請按此參閱實際頁面：",
      nameplaqueFootnote1: "閣下的感謝牌將於園區內公開展示。",
      nameplaqueFootnote2:
        "而內容只限於中文或英文，並最多只能顯示XX單元中文字或XX單元英文字（包含空格）。",
      nameplaqueFootnote3: "致謝牌匾預覽",
      nameplaqueFootnote4: "（實際縮放比例可能與預覽有所不同）:",
      selectedItem: "捐款資料：",
      email: "電郵地址",
      invalidEmail: "電郵地址不正確",
      pleaseInputValidEmail: "請輸入有效的電郵地址。",
      password: "密碼",
      loginFaster: "登入簡易捐款",
      existingAccount: "如果閣下已有西九文化區帳戶，只需於下方登錄即可。",
      incorrectPassword:
        "閣下的電子郵件地址未註冊或密碼不正確。 請重試或註冊一個新帳戶。 假如你忘記了密碼，請點擊「忘記密碼？」。",
      forgotPassword: "忘記密碼？",
      resetPasswordEmail: "我們將發送重置密碼到閣下的註冊電郵地址。",
      login: "登錄",
      logout: "登出",
      proceed: "繼續",
      yes: "是",
      no: "否",
      loginViaSalesforce: "登錄",
      createAccount: "建立帳戶",
      createAnAccount: "建立帳戶",
      createAccountNote_1: "建立",
      createAccountNote_2:
        "帳戶非常簡單，及更容易捐款。以下所輸入的個人資料均是安全可靠。",
      checkOut: "捐款",
      checkOutAsGuest: "以訪客身份捐款",
      checkOutNote: "無需建立新帳戶亦可完成捐款手續。",
      selectCreditCard: "選擇信用卡類別：",
      willRedirectToFirstData:
        "當完成選取信用卡後，你將會進入First Data 收款平台之頁面",
      followUs: "跟著我們",
      Dr: "博士",
      Mr: "先生",
      Mrs: "太太",
      Ms: "女士",
      Prof: "教授",
      //@TODO C4Sheep Removed NHR here.
      Nhr: "不需稱謂",
      "No honorific required": "不需稱謂",

      Anonymous: "無名氏捐款",
      "Supported by": "支持者",
      "In honour of": "向...致敬",
      "In memory of": "在記憶",
      footnoteTimeout: "按「確定」後，上述之資料將會開始暫存30分鐘。",
      acknowledgementNameWillPlace:
        "凡捐款達港幣一百元或以上均可於本頁之網上鳴謝頁面出現",
      errorFailLockAsset:
        "未能成功確認你所選的項目。您將被重定向到主頁以選擇另一個。",
      generalProjectExpired: "抱歉, 你想捐贈的項目已逾期。",
      errorNameplate: "包含不當語言，請更改。",
      errorBlockedName:
        "未能成功確認你所選的項目，請於以上欄目輸入閣下感謝牌之名字。",
      amountHKD: "總數 (港幣)",
      virtualPlaqueNote: "網上感謝牌將於網頁顯示",
      top: "頂部",
      Map: "地圖",
      List: "項目",
      English: "英文",
      Chinese: "中文",
      scientificName: "學名",
      PTN: {
        title: "注意事項",
        ptnLine1:
          "基金會是香港的註冊慈善組織；捐款達港幣 100 元或以上均可獲基金會發出捐款收據。 ",
        ptnLine2: "基金會暫時只接受一次性的港幣捐款。 ",
        ptnLine3: "所有捐贈予基金會的捐款均不設退款及不可轉讓。 ",
        ptnLine4: "相關之行政費用及網上收款平台之手續費均已包括在捐款內。",
        ptnLine5:
          "當收妥閣下之捐款連同捐款表格後，你將收到確認電郵，並將於 30 天內收到本基金會的電子收據。",
        ptnLine6:
          "閣下須保證你所提供的所有資料，包括但不限於姓名、聯絡電話、電子郵件和信用卡資料均真實、完整、最新及 正確無誤。 ",
        ptnLine7:
          "關於我們所提供之服務，可能會使用或包含非局方旗下或控制的第三方服務供應商， 當中包括但不限於網頁開 發商，網絡託管公司和網上付款平台等。相關之責任或義務將由第三方服務商負責，局方不需承擔任何責任。",
        ptnLine8:
          "本局有酌情權因某些原因拒絕任何捐款，包括但不限於可疑捐款、捐款者不遵守本表格內事項 或指示以及因相關的法律要求。",
        ptnLine9: "本基金會保留就任何爭議作出最終決定的權利",
        ptnLineAsterisk:
          "* 基金會等同於西九文化區基金會有限公司；管理局等同於西九文化管理管理局; 我們 / 局方 / 本局等同於本機構以及管理局; 本人、我 或閣下等同於捐款人。 ",
        ptnLatestUpdateDate: "01/03/2021",
      },
      PICS: {
        picHTML: "<div class=''>" +
          "    <h2 class=''>收集個人資料聲明</h2>" +
          "    <div class=''>" +
          "      <p><strong>有關收集閣下的個人資料</strong></p>" +
          "<p>為了向閣下提供我們的服務及改善客戶體驗，西九文化區管理局（「<strong>管理局</strong>」）以及其附屬公司包括但不限於M Plus Museum Limited、香港故宮文化博物館有限公司及西九文化區基金會有限公司（以下均稱為「<strong>局方</strong>」或「<strong>我們</strong>」）將收集閣下的個人資料。請注意，閣下必須在帶有星號的位置提供個人資料。若閣下不提供該些個人資料，我們可能無法為閣下提供某些信息、資料及／或閣下所要求的服務。</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>個人資料的收集及使用目的</strong></p>" +
          "<p>局方將會使用閣下的個人資料用作以下其中一項或多項目的：</p>" +
          "<ul><li>處理閣下對我們的服務要求（包括活動登記、門票購買、訂閱電子通訊、產品購買、使用Wi-Fi、註冊MyWestK帳戶、會籍註冊、租借場地以及捐款等）及向閣下提供相應服務；</li>" +
          "<li>管理閣下的會員帳戶及維持閣下的紀錄；</li>" +
          "<li>促進閣下與我們之間的溝通；</li>" +
          "<li>就可能影響閣下的服務更改通知閣下；</li>" +
          "<li>回應及跟進閣下的查詢；</li>" +
          "<li>通過閣下感興趣的節目及推廣以提升閣下於西九文化區的體驗；</li>" +
          "<li>在獲得閣下的明確同意後進行直接促銷；</li>" +
          "<li>管理局方內的客戶關係；</li>" +
          "<li>根據閣下的興趣喜好，在有關支持局方的途徑上與閣下作適當溝通；</li>" +
          "<li>進行及促進促銷活動、節目、抽獎或獎品兌換；</li>" +
          "<li>根據閣下的習慣、體驗、興趣及喜好, 在我們的網站、手機應用程式、社交媒體平台及其他平台（該些網站、手機應用程式及平台於下文均稱為「我們的平台」）上定制及發送內容、廣告、通知及其他信息；</li>" +
          "<li>管理、維護及改進我們的平台；</li>" +
          "<li>進行統計數據分析、研究、問卷調查、確保服務質素、行為分析及檢閱；及</li>" +
          "<li>其他與以上任何一項直接有關的目的。</li>" +
          "</ul><p>我們可能會從不同渠道收集及綜合／處理閣下的資料，例如線上渠道（網站、手機應用程式、社交媒體平台等）、離線渠道（申請表格等）、或有關閣下的公開資料。我們會用這些資料幫助提升閣下的體驗，以及就閣下可能感興趣的活動及推廣與閣下溝通。</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>個人資料的使用</strong></p>" +
          "<p>局方內會使用及共用所有收集到的個人資料作以上列出的目的。我們絕對不會向局方以外的機構出售或出租閣下的資料。我們可能會將閣下的個人資料轉移予我們的服務供應商（例如資訊科技承辦商、雲端服務提供者、活動代理及機密文件處置服務代理等），以便他們代表我們提供服務。我們亦可能會跟合辦活動的合作夥伴或提供商品及服務給閣下或處理閣下服務要求的服務供應商共用閣下的個人資料。我們也可能需要轉移閣下的個人資料至香港特別行政區境外作所需的處理及儲存。在與任何第三方合作夥伴（例如第三方網上平台及社交媒體平台等）共用個人資料用作直接促銷目的之前，我們會事先徵求閣下的同意。我們要求所有服務供應商尊重閣下個人資料的保安，以及遵守《個人資料（私隱）條例》（香港特別行政區法例第486章）（「條例」）及其他適用的個人資料相關法例。我們不允許我們的服務供應商出於其本身的目的使用閣下的個人資料，並只會允許他們為特定的目的及根據我們的指示處理閣下的個人資料。</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>位置資料</strong></p>" +
          "<p>我們使用「位置資料」部分中所述的位置數據來改善應用程式的結果，並用於下述目的。<br>" +
          "&nbsp;<br>" +
          "WestK 應用程式的使用者：如果閣下已啟用設備的位置服務，我們可能會在閣下打開應用程式時收集和使用閣下的起始位置資訊。如果閣下不允許設備的位置服務，我們只會收集閣下手動搜索的起點和終點。當閣下在 WestK 應用程式中共享閣下的位置時，我們會收集閣下全程的位置資訊。我們使用這些數據來提供導航支援，例如提供到達目的地的路線。</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>查閱或改正資料的要求</strong></p>" +
          "<p>閣下有權要求查閱及改正局方持有關於閣下的個人資料。該要求應以書面形式透過電郵（<a href='mailto:privacy@wkcda.hk'>privacy@wkcda.hk</a>）或郵寄／親身至「香港九龍西九文化區柯士甸道西8號西九文化區管理局大樓9樓」向「資料保障主任」提交。就我們的私隱政策詳情，閣下可以通過&nbsp;<a target='_blank' href='https://www.westk.hk/privacy'>https://www.westk.hk/privacy</a>&nbsp;參考我們的私隱政策聲明。</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>在直接促銷中使用資料</strong></p>" +
          "<p>我們有意使用閣下的個人資料及／或與局方內其他公司及我們的合作夥伴（包括第三方網上平台及社交媒體平台）共用閣下的個人資料作直接促銷用途，但除非我們得到閣下同意（包括表示不反對該使用及／或共用），否則我們不會如此使用及／或共用閣下的個人資料。直接促銷信息可能採取郵件、電子郵件、短信、針對性的網上廣告、通過我們的手機應用程式送出的通知、推送通知、即時通訊等形式。該些直接促銷信息可與局方的產品、活動、節目及服務有關（包括第三方贊助及／或局方與第三方聯合舉辦的, 以及在西九文化區內提供或進行的產品、活動、節目及服務）（「<strong>直接促銷信息</strong>」）。直接促銷信息的例子包括通訊、會員禮遇、商店／商品推廣、活動邀請、捐款邀請等。這些直接促銷信息可由局方及／或第三方代表我們發出（例如第三方網上平台及社交媒體平台）。在收集閣下的個人資料時，請閣下在相關的線上或線下表格中表明閣下同意或不反對該使用及／或共用。</p>" +
          "<p>" +
          "如果閣下不希望收到以上所提及的直接促銷信息，閣下可以免費隨時選擇拒收直接促銷信息，方法如下：</p>" +
          "<ul><li>點擊在我們發出的電子郵件底部的「取消訂閱」鏈接；</li>" +
          "<li>直接電郵至<a href='mailto:unsubscribe@wkca.hk'>unsubscribe@wkcda.hk</a>；或</li>" +
          "<li>郵寄至「香港九龍西九文化區柯士甸道西8號西九文化區管理局大樓9樓」聯絡我們的「資料保障主任」。</li>" +
          "</ul><p>如果閣下不希望收到有關籌款活動的信息（包括捐款推廣及／或局方的慈善或非牟利活動的捐款），閣下可以免費隨時選擇拒收籌款活動信息，只需將閣下的指示電郵到：<a href='mailto:development@wkcda.hk'>development@wkcda.hk</a>。</p>" +
          "<p>&nbsp;</p>" +
          "<p><strong>語言版本</strong></p>" +
          "<p>若本聲明的英文版本與中文版本存在差異，以英文版本為準。</p>" +
          "" +
          "    </div>" +
          "  </div>",
        title: "收集個人資料聲明",
        CollectionOfYourPersonalData_title: "有關收集個人資料 ",
        CollectionOfYourPersonalData_text:
          "為提供優質客戶體驗及服務，西九文化區管理局（管理局）及其轄下機構，包括西九文化區基金會有限公司（以下簡 稱“基金會”）（統稱為“局方”或“我們”）或有需要收集閣下的個人資料。請注意，閣下必須在帶有星號的空格 內填寫個人資料。若無法提供資料，局方可能無法提供相關資訊及/或閣下所要求關於捐款的服務，或處理捐款。 ",

        PurposesOfPersonalDataCollectionAndUsage_title:
          "個人資料的使用和收集目的 ",
        PurposesOfPersonalDataCollectionAndUsage_line_1:
          "局方將會使用閣下的個人資料用作以下用途：",
        PurposesOfPersonalDataCollectionAndUsage_point_1:
          "以專業和尊重的方式更新你的鳴謝資料、處理捐款，以及通知閣下捐款所帶來的影響； ",
        PurposesOfPersonalDataCollectionAndUsage_point_2:
          "處理你的服務要求（例如捐款、稅項收據、捐款鳴謝、捐款確認、活動登記、電子通訊訂閱等），並為你提供服務 ",
        PurposesOfPersonalDataCollectionAndUsage_point_3:
          "協助閣下與局方以及其轄下機構的溝通，以處理閣下的服務要求",
        PurposesOfPersonalDataCollectionAndUsage_point_4:
          "替閣下安排體驗最適合你個人喜好的西九文化區活動及推廣；",
        PurposesOfPersonalDataCollectionAndUsage_point_5:
          "通知閣下有關服務的更改；",
        PurposesOfPersonalDataCollectionAndUsage_point_6:
          "回應及跟進閣下的查詢； ",
        PurposesOfPersonalDataCollectionAndUsage_point_7:
          "進行統計數據分析、研究、問卷調查、確保服務質素及檢討；以及",

        PurposesOfPersonalDataCollectionAndUsage_line_2:
          "若閣下同意直接促銷： ",
        PurposesOfPersonalDataCollectionAndUsage_point_8:
          "將聯絡閣下以提供合適的西九文化區活動、服務、推廣、優惠資訊及拓展資訊（包括籌款活動和贊助）；",
        PurposesOfPersonalDataCollectionAndUsage_point_9:
          "根據閣下的興趣喜好，在有關支持局方或經濟上支持局方的途徑上與閣下保持適當的聯繫；以及 ",
        PurposesOfPersonalDataCollectionAndUsage_point_10:
          "其它與以上有關的目的。",

        PurposesOfPersonalDataCollectionAndUsage_line_3:
          "我們會將閣下從不同渠道所提供給我們的資料（線上渠道例如：網站/ 手機應用程式；離線渠道例如：申請表格或有 關閣下的公開資料）整合，從而替閣下安排最適合你個人喜好的體驗，以及就你可能有興趣的活動和推廣聯繫閣下。 ",

        TransferOfPersonalData_title: "個人資料的轉移",
        TransferOfPersonalData_line_1:
          "所有收集到的個人資料只會用作以上列出的用途。我們絕對不會出售、出租或將閣下的個人資料與局方以外的機構交 換。在將閣下的個人資料交給第三方前，我們必定會先得到你的同意。為了代表局方提供服務，某些局方的服務供應 商將能夠查閱你的個人資料。我們要求所有服務供應商重視閣下個人資料的保安，以及遵守《個人資料 ( 私隱 ) 條例》 ( 香港特別行政區法例第 486 章 )。服務供應商需要遵守局方特定的要求和指示，局方才會容許他們就指定的目的處理 閣下的個人資料。我們絕不允許服務供應商為了其本身目的使用閣下的個人資料。 ",

        TransferOfPersonalDataOutsideHongKong_title:
          "個人資料的轉移（香港以外）",
        TransferOfPersonalDataOutsideHongKong_text_1:
          "收集的個人資料有可能位處於香港境內或境外，閣下的資料可能會過境轉移至香港以外的地方以作相關處理或儲存。 ",

        PersonalDataSecurityAndRetentionOfData_title: "個人資料的保安及保存",
        PersonalDataSecurityAndRetentionOfData_text_1:
          "根據《個人資料（私隱）條例》，我們不會保留閣下的個人資料超過所需的時間，並會遵守香港特別行政區一切有關 保存個人資料的法例及監管規定。閣下經線上申請表提交之資料將會以加密方式發送給局方。閣下保存在局方的個人 資料只能由局方授權的員工或承包商查閱或接觸。",

        Personaldatasecurityandretentionofdatatitle: "要求查閱或改正資料 ",
        Personaldatasecurityandretentionofdatatext_1:
          '閣下有權要求查閱或改正所有由局方持有關於你的個人資料。若有需要，請以書面形式透過電郵 (<a href="mailto:privacy@wkcda.hk">privacy@wkcda.hk</a>) 或郵寄致「香港九龍西九文化區柯士甸道西8號西九文化區管理局大樓9樓」聯絡我們的「資料保障主任」。 詳情請查詢我們的私隱政策  <a href="https://www.westkowloon.hk/privacy">https://www.westkowloon.hk/privacy</a> 。 ',

        DataAccessAndCorrectionRequeststitle: "要求查閱或改正資料 ",
        DataAccessAndCorrectionRequeststext_1:
          '閣下有權要求查閱或改正所有由局方持有關於你的個人資料。若有需要，請以書面形式透過電郵 (<a href="mailto:privacy@wkcda.hk">privacy@wkcda.hk</a>) 或郵寄致「香港九龍西九文化區柯士甸道西8號西九文化區管理局大樓9樓」西九文化管理局聯絡我們的「資料保障主任」。 詳情請查詢我們的私隱政策 <a href="https://www.westkowloon.hk/privacy">https://www.westkowloon.hk/privacy</a> 。',

        UseOfDataInDirectMarketing_title: "在直接促銷中使用資料",
        UseOfDataInDirectMarketing_text_1:
          "我們有意將閣下的個人資料作直接促銷用途，但除非得到閣下同意(包括表示不反對)，否則我們不可在直接促銷中使 用閣下的資料。 ",
        UseOfDataInDirectMarketing_text_2:
          "我們可能會使用閣下的姓名、聯絡資料（例如電郵地址）、偏好及興趣、行爲資料及交易模式，用作提供給你西九文 化區及/或局方內最符合閣下興趣的拓展資訊、慈善項目、活動、服務、宣傳和特別優惠，或支持我們的途徑。若閣 下不同意有關使用，請於捐款表格內「聲明及同意書」下剔選相關空格。 ",

        UseOfDataInDirectMarketing_text_3:
          "如果閣下不希望接收到以上所提及的直接促銷信息，你可以免費隨時選擇拒收直接促銷信息，方法如下： ",
        UseOfDataInDirectMarketing_point_1:
          "點擊在局方發出的電子郵件底部的「取消訂閱」鏈接；",
        UseOfDataInDirectMarketing_point_2:
          '直接電郵至 <a href="mailto:unsubscribe@wkcda.hk">unsubscribe@wkcda.hk</a>; 或 ',
        UseOfDataInDirectMarketing_point_3:
          "郵寄至「香港九龍西九文化區柯士甸道西8號西九文化區管理局大樓9樓」聯絡我們的「資料保障主任」",

        UseOfDataInDirectMarketing_text_4:
          '如果閣下不希望接收到有關籌款活動的消息（包括捐贈的優惠或參與慈善或非牟利活動），你可以免費隨時選擇拒收 籌款活動消息，只需將你的指示電郵到：<a href="mailto:development@wkcda.hk">development@wkcda.hk</a>。 ',

        LanguageVersions_title: "不同語言版本",
        LanguageVersions_line_1:
          "若本聲明的中文版本與英文版本存在差異，以英文版本為準。",
        picsLatestUpdateDate: "01/03/2021",
      },
      form: {
        personalInfo: "個人資料",
        mustInput: "下列有 * 為必須填寫之欄目",
        title: "稱謂*",
        firstName: "名*",
        lastName: "姓*",
        taxDeductibleNote: "以上之名字將會用於本基金會之捐款收據上",
        overrideWestkowloonAccounts:
          "我同意以上述最新的資料取替本人之前所提供的個人資料（包括姓名和電話）",
        phone: "電話號碼*",
        phoneLengthRequired: "電話號碼必須為{{length}}位數字或以上。",
        areaCode: "地區號碼",
        venuesHeader: "你對我們以下那個場地有興趣",
        languagePref: "語言選擇*",
        receipt: "收據",
        receiptNote:
          "我們稍後將會把電子收據發予你，請確保以上所輸入之電郵地址正確無誤。如閣下需要列印版收據，請在以下欄目加上「✓」號。 列印本收據將於一個月內發出。",
        receiptNote_pa: "我們稍後將會把電子收據發予你。",
        receiptCheckboxNote:
          "請在此欄目加上「✓」號，並在下方提供你的郵寄地址。",
        receiptCheckboxNote_pa:
          "如閣下需要收據正本，請劃上「✓」號 。 收據正本將於一個月內發出",

        PICHeader: "個人資料收集聲明",
        PICaria: "我在此聲明",
        PICStatement1:
          "我在此聲明我已仔細閱讀相關資料，並完全明白及同意受西九文化區基金會的",
        termsAndConditions: "注意事項",
        and: "和",
        PICS: "個人資料收集聲明",
        PICStatement2:
          "所約束。同時，我允許西九文化區基金會使用本人之個人資料，並明白本人有權按照個人資料收集聲明條例，要求存取及更改我的個人資料。",
        dataUseMarketing: "使用資料作直接促銷",
        marketingPurpose:
          "我們將使用你的名字、聯絡資料(如電子郵件)、個人喜好、興趣、檔案信息、交易資料，並根據你的興趣，為你提供在西九文化區內舉行相關之活動、服務、推廣以及特別折扣的資訊，以及支持本基金會的方法。",
        eNewsNotification:
          "*如你早前已訂閱西九電子通訊,可隨時透過附設在任何一期電子通訊底部的連結取消訂閱。",
        checkboxReceiveInfo:
          "我希望收到有關由西九文化區舉辦或於文化區內舉行的活動資料。",
        checkboxReceiveDevUpdates: "我希望收到關於西九發展的最新拓展資訊。",
        revise: "上一頁",
        addressLine1: "居住地址 1",
        addressLine2: "居住地址 2",
        roomFloorBlock: "室／樓層／座",
        buildingEstateStreet: "大廈／屋苑名稱／街道",
        region: "地區",
        district: "區域",
        area: "各區",
        hongKong: "香港",
        termsAndConditionsURL:
          "https://www.westkowloon.hk/tc/footer/privacy-policy#pps",
        PICSURL: "https://www.westkowloon.hk/tc/footer/privacy-policy#pps",
      },
      venue: {
        "WKCDA General": "西九文化區一般慈善項目", // '西九龍文化區一般',
        artPark: "藝術公園",
        palaceMuseum: "香港故宮文化博物館",
        mPlus: "M+",
        xiquCentre: "戲曲中心",
        lyricThreatre: "演藝綜合劇場",
        freespace: "自由空間",
        "West Kowloon Cultural District in General": "西九文化區一般慈善項目", // '西九龍文化區一般',
        "Art Park": "藝術公園",
        "Hong Kong Palace Museum": "香港故宮文化博物館",
        "M+": "M+",
        "Xiqu Centre": "戲曲中心",
        "Lyric Theatre Complex": "演藝綜合劇場",
        Freespace: "自由空間",
      },
      filter: {
        showDonorsNearby: "顯示附近捐贈者",
        tree: "助養樹木",
        bench: "石椅留芳名",
        seat: "一人一石",
        price: "價格",
        woodland: "內園",
        seaside: "海傍",
        // "urbanForest": "城市森林",
        // "orchard": "果園",
        reset: "重置過濾器",
      },
      success: {
        title_thankyou: "衷心感謝！",
        title_fail: "捐款程序尚未完成",
        fail: "抱歉閣下的捐款未能完成，請與您的銀行聯絡，或再核實有關資料是否正確。",
        failLine2:
          "你的捐款將為西九文化區帶來不一樣的改變，殷切期待閣下的支持！",
        failLine3: "",
        failLine4:
          "如有任何查詢，歡迎電郵至<a href='mailto:donation@wkcda.hk'>donation@wkcda.hk</a>與我們聯絡。",
        thankYou: "感謝閣下對西九文化區的慷慨支持！",
        thankYou2: "待捐款確認後，我們將於一個月內發出捐款收據。",
        thankYou3:
          "您的支持為西九文化區注入新力量，讓我們可持續多元藝術製作，使更多人能夠接觸及欣賞不同文化藝術展覽及表演活動。",
        thankYou4:
          "閣下對捐款事宜如有任何查詢，歡迎電郵至<a href='mailto:donation@wkcda.hk'>donation@wkcda.hk</a>與我們聯絡。",

        donationReceived:
          "您的捐款已收到好評，並且在審核過程中捕獲了以下詳細信息：",
        amount: "您的捐款金額：{{price}}",
        donationAcknowledgement: "您的捐贈確認將顯示為：{{acknowledgement}}",
        receiptName: "正式收據上的姓名：{{name}}",
        ref: "捐款編號：{{donationId}}",
        type: "捐贈類型：{{projectType}}",
        assetName: "資產名稱： {{assetName}}",
        message: "信息：{{message}}",
        taxReceipt:
          "在30天之內確認捐款後，便會為您準備一張稅收收據，並將與您共享相關的確認宣傳材料。",
        contactYou:
          "同時，我們可能會與您聯繫，以提出建議的命名（如果需要）或其他相關問題。",
        reachUsAt: `代表西九龍的每個人，來自本地和國際藝術界的藝術才華以及來自香港和世界各地的數百萬藝術愛好者-謝謝！ 如果您對捐款有任何疑問，請通過donation@wkcda.hk與我們聯繫。`,
        donateAgain: "再次捐款",
        backWestKowloon: "返回基金會主頁",
        donateAgainURLG: "https://support-uat.westkowloon.hk/tc/donate-now-hk/",
        donateAgainURLA: "https://support-uat.westkowloon.hk/donation/?lng=hk",
        backWestKowloonURL: "https://support-uat.westkowloon.hk/tc/home-hk/",
      },
      cookies: {
        cookies_experience: "我們在本網站上使用Cookies來增強您的用戶體驗。",
        more_info: "更多資訊",
        agree: "我同意",
      },
      notFound: {
        notExist: "該頁面不存在",
        backHome: "返回主頁",
        uri: "https://support-uat.westkowloon.hk/tc/home-hk/",
      },
      "Hong Kong SAR": "香港特別行政區",
      China: "中國",
      "Macau SAR": "澳門特區",
      Afghanistan: "阿富汗",
      Albania: "阿爾巴尼亞",
      Algeria: "阿爾及利亞",
      "American Samoa": "美屬薩摩亞",
      Andorra: "安道爾",
      Angola: "安哥拉",
      Anguilla: "安圭拉",
      Antarctica: "南極洲",
      "Antigua and Barbuda": "安提瓜和巴布達",
      Argentina: "阿根廷",
      Armenia: "亞美尼亞",
      Aruba: "阿魯巴",
      Australia: "澳大利亞",
      Austria: "奧地利",
      Azerbaijan: "阿塞拜疆",
      Bahamas: "巴哈馬",
      Bahrain: "巴林",
      Bangladesh: "孟加拉國",
      Barbados: "巴巴多斯",
      Belarus: "白俄羅斯",
      Belgium: "比利時",
      Belize: "伯利茲",
      Benin: "貝寧",
      Bermuda: "百慕大",
      Bhutan: "不丹",
      Bolivia: "玻利維亞",
      "Bonaire, Sint Eustatius and Saba": "博內爾島,聖尤斯特歇斯和薩巴島",
      "Bosnia and Herzegovina": "波斯尼亞和黑塞哥維那",
      Botswana: "博茨瓦納",
      "Bouvet Island": "布威島",
      Brazil: "巴西",
      "British Indian Ocean Territory": "英屬印度洋領地",
      Brunei: "文萊",
      Bulgaria: "保加利亞",
      "Burkina Faso": "布基納法索",
      Burundi: "布隆迪",
      Cambodia: "柬埔寨",
      Cameroon: "喀麥隆",
      Canada: "加拿大",
      "Cape Verde": "佛得角",
      "Cayman Islands": "開曼群島",
      "Central African Republic": "中非共和國",
      Chad: "乍得",
      Chile: "智利",
      "Christmas Island": "聖誕島",
      "Cocos (Keeling) Islands": "科科斯（基林）群島",
      Colombia: "哥倫比亞",
      Comoros: "科摩羅",
      "Congo, Democratic Republic of the": "剛果民主共和國",
      "Congo, Republic of the": "剛果共和國",
      "Cook Islands": "庫克群島",
      "Costa Rica": "哥斯達黎加",
      "Cote d'Ivoire": "科特迪瓦",
      Croatia: "克羅地亞",
      Cuba: "古巴",
      Curacao: "庫拉索",
      Cyprus: "塞浦路斯",
      "Czech Republic": "捷克共和國",
      Denmark: "丹麥",
      Djibouti: "吉布提",
      Dominica: "多米尼加",
      "Dominican Republic": "多明尼加共和國",
      Ecuador: "厄瓜多爾",
      Egypt: "埃及",
      "El Salvador": "薩爾瓦多",
      "Equatorial Guinea": "赤道幾內亞",
      Eritrea: "厄立特里亞",
      Estonia: "愛沙尼亞",
      Ethiopia: "埃塞俄比亞",
      "Falkland Islands (Islas Malvinas)": "福克蘭群島（馬爾維納斯島）",
      "Faroe Islands": "法羅群島",
      Fiji: "斐濟",
      Finland: "芬蘭",
      France: "法國",
      "French Guiana": "法屬圭亞那",
      "French Polynesia": "法屬波利尼西亞",
      "French Southern and Antarctic Lands": "法國南部和南極土地",
      Gabon: "加蓬",
      Gambia: "岡比亞",
      Georgia: "喬治亞州",
      Germany: "德國",
      Ghana: "加納",
      Gibraltar: "直布羅陀",
      Greece: "希臘",
      Greenland: "格陵蘭",
      Grenada: "格林納達",
      Guadeloupe: "瓜德羅普島",
      Guam: "關島",
      Guatemala: "危地馬拉",
      Guernsey: "根西島",
      Guinea: "幾內亞",
      "Guinea-Bissau": "幾內亞比紹",
      Guyana: "圭亞那",
      Haiti: "海地",
      "Heard Island and McDonald Islands": "希爾德島和麥當勞群島",
      "Holy See (Vatican City)": "羅馬教廷（梵蒂岡）",
      Honduras: "洪都拉斯",
      Hungary: "匈牙利",
      Iceland: "冰島",
      India: "印度",
      Indonesia: "印度尼西亞",
      Iran: "伊朗",
      Iraq: "伊拉克",
      Ireland: "愛爾蘭",
      "Isle of Man": "人島",
      Israel: "以色列",
      Italy: "意大利",
      Jamaica: "牙買加",
      Japan: "日本",
      Jersey: "澤西",
      Jordan: "約旦",
      Kazakhstan: "哈薩克斯坦",
      Kenya: "肯尼亞",
      Kiribati: "基里巴斯",
      "Korea, North": "北朝鮮",
      "Korea, South": "南柯爾",
      Kosovo: "科索沃",
      Kuwait: "科威特",
      Kyrgyzstan: "吉爾吉斯斯坦",
      Laos: "老撾",
      Latvia: "拉脫維亞",
      Lebanon: "黎巴嫩",
      Lesotho: "萊索托",
      Liberia: "利比里亞",
      Libya: "利比亞",
      Liechtenstein: "列支敦士登",
      Lithuania: "立陶宛",
      Luxembourg: "盧森堡",
      Macedonia: "馬其頓",
      Madagascar: "馬達加斯加",
      Malawi: "馬拉維",
      Malaysia: "馬來西亞",
      Maldives: "馬爾代夫",
      Mali: "馬里",
      Malta: "馬耳他",
      "Marshall Islands": "馬紹爾群島",
      Martinique: "馬提尼克島",
      Mauritania: "毛里塔尼亞",
      Mauritius: "毛里求斯",
      Mayotte: "馬約特島",
      Mexico: "墨西哥",
      Micronesia: "密克羅尼西亞",
      Moldova: "摩爾多瓦",
      Monaco: "摩納哥",
      Mongolia: "蒙古",
      Montenegro: "黑山",
      Montserrat: "蒙特塞拉特",
      Morocco: "摩洛哥",
      Mozambique: "莫桑比克",
      Myanmar: "緬甸",
      Namibia: "納米比亞",
      Nauru: "瑙魯",
      Nepal: "尼泊爾",
      Netherlands: "荷蘭",
      "New Caledonia": "新喀裡多尼亞",
      "New Zealand": "新西蘭",
      Nicaragua: "尼加拉瓜",
      Niger: "尼日爾",
      Nigeria: "尼日利亞",
      Niue: "紐埃",
      "Norfolk Island": "諾福克島",
      "Northern Mariana Islands": "北馬里亞納群島",
      Norway: "挪威",
      Oman: "阿曼",
      Pakistan: "巴基斯坦",
      Palau: "帕勞",
      Panama: "巴拿馬",
      "Papua New Guinea": "巴布亞新幾內亞",
      Paraguay: "巴拉圭",
      Peru: "秘魯",
      Philippines: "菲律賓",
      "Pitcairn Islands": "皮特凱恩群島",
      Poland: "波蘭",
      Portugal: "葡萄牙",
      "Puerto Rico": "波多黎各",
      Qatar: "卡塔爾",
      Reunion: "團圓",
      Romania: "羅馬尼亞",
      Russia: "俄國",
      Rwanda: "盧旺達",
      "Saint Barthelemy": "聖巴泰勒米",
      "Saint Helena, Ascension, and Tristan da Cunha":
        "聖海倫娜,升天和特里斯坦·達庫尼亞",
      "Saint Kitts and Nevis": "聖基茨和尼維斯",
      "Saint Lucia": "聖盧西亞",
      "Saint Martin": "聖馬丁",
      "Saint Pierre and Miquelon": "聖皮埃爾和密克隆群島",
      "Saint Vincent and the Grenadines": "聖文森特和格林納丁斯",
      Samoa: "薩摩亞",
      "San Marino": "聖馬力諾",
      "Sao Tome and Principe": "聖多美和普林西比",
      "Saudi Arabia": "沙特阿拉伯",
      Senegal: "塞內加爾",
      Serbia: "塞爾維亞",
      Seychelles: "塞舌爾",
      "Sierra Leone": "塞拉利昂",
      Singapore: "新加坡",
      "Sint Maarten": "聖馬丁",
      Slovakia: "斯洛伐克",
      Slovenia: "斯洛文尼亞",
      "Solomon Islands": "所羅門群島",
      Somalia: "索馬里",
      "South Africa": "南非",
      "South Georgia and the Islands": "南喬治亞島",
      "South Sudan": "南蘇丹",
      Spain: "西班牙",
      "Sri Lanka": "斯里蘭卡",
      "State of Palestine": "巴勒斯坦國",
      Sudan: "蘇丹",
      Suriname: "蘇里南",
      Svalbard: "斯瓦爾巴群島",
      Swaziland: "斯威士蘭",
      Sweden: "瑞典",
      Switzerland: "瑞士",
      Syria: "敘利亞",
      Taiwan: "台灣",
      Tajikistan: "塔吉克斯坦",
      Tanzania: "坦桑尼亞",
      Thailand: "泰國",
      Timor: "東帝汶",
      Togo: "多哥",
      Tokelau: "托克勞",
      Tonga: "湯加",
      "Trinidad and Tobago": "特立尼達和多巴哥",
      Tunisia: "突尼斯",
      Turkey: "火雞",
      Turkmenistan: "土庫曼斯坦",
      "Turks and Caicos Islands": "特克斯和凱科斯群島",
      Tuvalu: "圖瓦盧",
      Uganda: "烏干達",
      Ukraine: "烏克蘭",
      "United Arab Emirates": "阿拉伯聯合酋長國",
      "United Kingdom": "英國",
      "United States": "美國",
      "United States Minor Outlying Islands": "美國本土外小島嶼",
      Uruguay: "烏拉圭",
      Uzbekistan: "烏茲別克斯坦",
      Vanuatu: "瓦努阿圖",
      Venezuela: "委內瑞拉",
      Vietnam: "越南",
      "Virgin Islands (British)": "維爾京群島（英國）",
      "Virgin Islands (U.S.)": "維京群島（美國）",
      "Virgin Islands (US.)": "維京群島（美國）",
      "Wallis and Futuna": "沃利斯和富圖納群島",
      "Western Sahara": "撒哈拉沙漠西部",
      Yemen: "也門",
      Zambia: "贊比亞",
      Zimbabwe: "津巴布韋",
      "Åland Islands": "奧蘭群島",
      "Hong Kong Island": "香港島",
      Kowloon: "九龍",
      "New Territories": "新界",
      "Central and Western": "香港中西",
      Eastern: "香港東",
      Southern: "香港南",
      "Wan Chai": "灣仔",
      "Kowloon City": "九龍城",
      "Kwun Tong": "觀塘",
      "Sham Shui Po": "深水埗",
      "Wong Tai Sin": "黃大仙",
      "Yau Tsim Mong": "油尖旺",
      Islands: "島嶼",
      "Kwai Tsing": "葵青",
      North: "北區",
      "Sai Kung": "西貢",
      "Sha Tin": "沙田",
      "Tai Po": "大埔",
      "Tsuen Wan": "荃灣",
      "Tuen Mun": "屯門",
      "Yuen Long": "元朗",
      "Kennedy Town": " 堅尼地城",
      "Shek Tong Tsui": "石塘咀",
      "Sai Ying Pun": "西營盤",
      "Sheung Wan": "上環",
      Central: "中央",
      Admiralty: "金鐘",
      "Mid-levels": "半山區",
      Peak: "山頂",
      "Tin Hau": "天后",
      "Braemar Hill": "寶馬山",
      "North Point": "北角",
      "Quarry Bay": "鰂魚涌",
      "Sai Wan Ho": "西灣河",
      "Shau Kei Wan": "筲箕灣",
      "Chai Wan": "柴灣",
      "Siu Sai Wan": "小西灣",
      "Pok Fu Lam": "薄扶林",
      Aberdeen: "香港仔",
      "Ap Lei Chau": "鴨脷洲",
      "Wong Chuk Hang": "黃竹坑",
      "Shouson Hill": "壽臣山",
      "Repulse Bay": "淺水灣",
      "Chung Hom Kok": "中坎角",
      Stanley: "赤柱",
      "Tai Tam": "大潭",
      "Shek O": "石澳",
      "Wan Chai": "灣仔",
      "Causeway Bay": "銅鑼灣",
      "Happy Valley": "跑馬地",
      "Tai Hang": "大坑",
      "So Kon Po": "掃桿埔",
      "Jardine's Lookout": "渣甸山",
      "Hung Hom": "紅磡",
      "To Kwa Wan": "土瓜灣",
      "Ma Tau Kok": "馬頭角",
      "Ma Tau Wai": "馬頭圍",
      "Kai Tak": "啟德",
      "Kowloon City": "九龍城",
      "Ho Man Tin": "何文田",
      "Kowloon Tong": "九龍塘",
      "Beacon Hill": "筆架山",
      "Ping Shek": "平石",
      "Kowloon Bay": "九龍灣",
      "Ngau Tau Kok": "牛頭角",
      "Jordan Valley": "佐敦",
      "Kwun Tong": "觀塘",
      "Sau Mau Ping": "秀茂坪",
      "Lam Tin": "藍田",
      "Yau Tong": "油塘",
      "Lei Yue Mun": "鯉魚門",
      "Mei Foo": "美孚",
      "Lai Chi Kok": "荔枝角",
      "Cheung Sha Wan": "長沙灣",
      "Sham Shui Po": "深水埗",
      "Shek Kip Mei": "石硤尾",
      "Yau Yat Tsuen": "又一村",
      "Tai Wo Ping": "太和坪",
      "Stonecutters Island": "昂船洲",
      "San Po Kong": "新蒲崗",
      "Wong Tai Sin": "黃大仙",
      "Tung Tau": "桐頭",
      "Wang Tau Hom": "橫頭磡",
      "Lok Fu": "樂富",
      "Diamond Hill": "鑽石山",
      "Tsz Wan Shan": "慈雲山",
      "Ngau Chi Wan": "牛池灣",
      "Tsim Sha Tsui": "尖沙咀",
      "Yau Ma Tei": "油麻地",
      "West Kowloon Reclamation": "西九龍填海區",
      "King's Park": "京士柏",
      "Mong Kok": "旺角",
      "Tai Kok Tsui": "大角咀",
      "Cheung Chau": "長洲",
      "Peng Chau": "彭州",
      "Lantau Island (incl. Tung Chung)": "大嶼山（包括東涌）",
      "Lantau Island (incl Tung Chung)": "大嶼山（包括東涌）",
      "Lamma Island": "南丫島",
      "Kwai Chung": "葵涌",
      "Tsing Yi": "青衣",
      Fanling: "粉嶺",
      "Luen Wo Hui": "聯和會",
      "Sheung Shui": "上水",
      "Shek Wu Hui": "石湖墟",
      "Sha Tau Kok": "沙頭角",
      "Luk Keng": "陸恭",
      "Wu Kau Tang": "烏蛟騰",
      "Clear Water Bay": "清水灣",
      "Sai Kung": "西貢",
      "Tai Mong Tsai": "大孟仔",
      "Tseung Kwan O": "將軍澳",
      "Hang Hau": "坑口",
      "Tiu Keng Leng": "調景嶺",
      "Ma Yau Tong": "馬友堂",
      "Tai Wai": "大圍",
      "Sha Tin": "沙田",
      "Fo Tan": "火炭",
      "Ma Liu Shui": "馬六水",
      "Wu Kai Sha": "烏溪沙",
      "Ma On Shan": "馬鞍山",
      "Tai Po Market": "大埔墟",
      "Tai Po": "大埔",
      "Tai Po Kau": "大埔滘",
      "Tai Mei Tuk": "大尾篤",
      "Shuen Wan": "信灣",
      "Cheung Muk Tau": "樟木頭",
      "Kei Ling Ha": "企嶺下",
      "Tsuen Wan": "荃灣",
      "Lei Muk Shue": "李木樹",
      "Ting Kau": "汀九",
      "Sham Tseng": "深井",
      "Tsing Lung Tau": "青龍頭",
      "Ma Wan": "馬灣",
      "Sunny Bay": "陽光灣",
      "Tai Lam Chung": "大欖湧",
      "So Kwun Wat": "掃管笏",
      "Tuen Mun": "屯門",
      "Lam Tei": "藍地",
      "Hung Shui Kiu": "洪水橋",
      "Ha Tsuen": "下村",
      "Lau Fau Shan": "琉浮山",
      "Tin Shui Wai": "天水圍",
      "Yuen Long": "元朗",
      "San Tin": "新田",
      "Lok Ma Chau": "落馬洲",
      "Kam Tin": "錦田",
      "Shek Kong": "石崗",
      "Pat Heung": "八鄉",
    },
  },
  cn: {
    translation: {
      Copied: "已复制",
      ackLink_1_1: "以上每个填满的圆点均代表我们宝贵的捐助者之贡献。",
      ackLink_1_2: "你也可以加入他们的行列，携手填满上图。 欢迎你的支持：",
      ackLink_2: "请按此",
      ackLink_3: "，感谢！",
      ackLink_link: "/../sc/donate-now-cn/",

      ackPageHeading: "鸣谢",
      ackTagline: "感谢以下支持者对我们慷慨的捐助",

      fbshareQuote:
        "我捐款支持了西九文化区的筹款活动！欢迎加入我的行列，以表示对香港艺术和文化发展的支持！",
      fbshareHash: "#西九文化区",
      logoRedirectURL: "https://support-uat.westkowloon.hk/sc/home-cn/",
      invalidDonationAmount: "捐款金额不能留空。请输入捐赠的金额。",
      en: "EN",
      zhTW: "繁中",
      cn: "简中",
      hello: "{{user}}，你好！",
      alreadyLogin: "阁下已经以{{user}}身份登入，是否以相同身份继续？",
      user: "用户",
      required: "必需。",
      requiredTerms: "必需接受条款和条件。",
      noneAvailable: "没有",
      keywordSearch: "搜寻...",
      select: "确认",
      noItemsAvailable: "没有这样的物品。",
      donationAmount: "捐款金额",
      nameplaque: "感谢牌",
      nameplaqueInfo: "感谢牌资料",
      acknowledgementName: "确认名称",
      acknowledgementNameInfo: "捐款资料",
      personalInfo: "个人资料",
      confirm: "确认",
      next: "下一步",
      copyrightText0: "WestK及WestK标志均为西九文化区管理局的商标。",
      copyrightText: "©2024 西九文化区管理局。保留所有权利。",
      confirmPay: "确认及付款",
      //      displayName: "阁下的名字将会显示在本网页以示感谢 , 请参见下列之示意图",
      displayName:
        "为表示感谢，阁下的名字或会在西九文化基金会的网站发布，请在以下位置填写你指定之名字",
      thankYouSupport: "感谢你的支持！（阁下的感谢牌将会显示为：无名氏）",
      anonymous: "无名氏",
      leaveBlank: "阁下如想以匿名捐赠, 请将此栏目留空。",
      dummyReference: "以下為感謝頁面示意圖，請按此參閱實際頁面：",
      nameplaqueFootnote1: "阁下的感谢牌将于园区内公开展示。",
      nameplaqueFootnote2:
        "而内容只限于中文或英文，并最多只能显示XX单元中文字或XX单元英文字（包含空格）。",
      nameplaqueFootnote3: "致谢牌匾预览",
      nameplaqueFootnote4: "（实际缩放比例可能与预览有所不同）:",
      selectedItem: "捐款资料：",
      email: "电邮地址",
      invalidEmail: "电邮地址不正确",
      pleaseInputValidEmail: "请输入有效的电邮地址。",
      password: "密码",
      loginFaster: "登入简易捐款",
      existingAccount: "如果阁下已有西九文化区帐户，只需于下方登录即可。",
      incorrectPassword:
        "阁下的电子邮件地址未注册或密码不正确。请重试或注册一个新帐户。假如你忘记了密码，请点击「忘记密码？」。",
      forgotPassword: "忘记密码？",
      resetPasswordEmail: "我们将发送重置密码到阁下的注册电邮地址。",
      login: "登录",
      logout: "登出",
      proceed: "继续",
      yes: "是",
      no: "否",
      loginViaSalesforce: "登录",
      createAccount: "建立帐户",
      createAnAccount: "建立帐户",
      createAccountNote_1: "建立",
      createAccountNote_2:
        "帐户非常简单，及更容易捐款。以下所输入的个人资料均是安全可靠。",
      checkOut: "捐款",
      checkOutAsGuest: "以访客身份捐款",
      checkOutNote: "无需建立新帐户亦可完成捐款手续。",
      selectCreditCard: "选择信用卡类别：",
      willRedirectToFirstData:
        "当完成选取信用卡后，你将会进入First Data 收款平台之页面",
      followUs: "跟着我们",
      Dr: "博士",
      Mr: "先生",
      Ms: "女士",
      Prof: "教授",

      //@TODO C4Sheep Removed NHR here.

      Nhr: "不需稱謂",
      "No honorific required": "不需稱謂",

      Anonymous: "无名氏捐款",
      "Supported by": "支持者",
      "In honour of": "向...致敬",
      "In memory of": "在记忆",
      footnoteTimeout: "按「确定」后，上述之资料将会开始暂存30分钟。 ",
      acknowledgementNameWillPlace:
        "凡捐款达港币一百元或以上均可于本页之网上鸣谢页面出现",
      errorFailLockAsset:
        "未能成功确认你所选的项目。您将被重定向到主页以选择另一个。 ",
      generalProjectExpired: "抱歉, 你想捐赠的项目已逾期。",
      errorNameplate: "包含不当语言，请更改。",
      errorBlockedName:
        "未能成功确认你所选的项目，请于以上栏目输入阁下感谢牌之名字。 ",
      amountHKD: "总数 (港币)",
      virtualPlaqueNote: "网上感谢牌将于网页显示",
      top: "顶部",
      Map: "地图",
      List: "项目",
      English: "英文",
      Chinese: "中文",
      scientificName: "学名",
      PTN: {
        title: "注意事项",
        ptnLine1:
          "基金会是香港的注册慈善组织；捐款达港币 100 元或以上均可获基金会发出捐款收据。 ",
        ptnLine2: "基金会暂时只接受一次性的港币捐款。 ",
        ptnLine3: "所有捐赠予基金会的捐款均不设退款及不可转让。 ",
        ptnLine4: "相关之行政费用及网上收款平台之手续费均已包括在捐款内。",
        ptnLine5:
          "当收妥阁下之捐款连同捐款表格後，你将收到确认电邮，并将於 30 天内收到本基金会的电子收据。",
        ptnLine6:
          "阁下须保证你所提供的所有资料，包括但不限於姓名丶联络电话丶电子邮件和信用卡资料均真实丶完整丶最新及 正确无误。 ",
        ptnLine7:
          "关於我们所提供之服务，可能会使用或包含非局方旗下或控制的第三方服务供应商， 当中包括但不限於网页开 发商，网络托管公司和网上付款平台等。相关之责任或义务将由第三方服务商负责，局方不需承担任何责任。",
        ptnLine8:
          "本局有酌情权因某些原因拒绝任何捐款，包括但不限於可疑捐款丶捐款者不遵守本表格内事项 或指示以及因相关的法律要求。",
        ptnLine9: "本基金会保留就任何争议作出最终决定的权利",
        ptnLineAsterisk:
          "* 基金会等同於西九文化区基金会有限公司；管理局等同於西九文化管理管理局; 我们 / 局方 / 本局等同於本机构以及管理局; 本人丶我 或阁下等同於捐款人。 ",
        ptnLatestUpdateDate: "01/03/2021",
      },
      PICS: {
        picHTML: "<div class=''>" +
          " <h2 class=''>收集个人资料声明</h2>" +
          " <div class=''>" +

          " <p><strong>有关收集阁下的个人资料</strong></p>" +

          "<p>为了向阁下提供我们的服务及改善客户体验，西九文化区管理局（「<strong>管理局</strong>」）以及其附属公司包括但不限于M Plus Museum Limited、香港故宫文化博物馆有限公司及西九文化区基金会有限公司（以下均称为「<strong>局方</strong>」或「<strong>我们</strong>」）将收集阁下的个人资料。请注意，阁下必须在带有星号的位置提供个人资料。若阁下不提供该些个人资料，我们可能无法为阁下提供某些信息、资料及／或阁下所要求的服务。</p>" +

          "<p>&nbsp;</p>" +

          "<p><strong>个人资料的收集及使用目的</strong></p>" +

          "<p>局方将会使用阁下的个人资料用作以下其中一项或多项目的：</p>" +

          "<ul><li>处理阁下对我们的服务要求（包括活动登记、门票购买、订阅电子通讯、产品购买、使用Wi-Fi、注册MyWestK帐户、会籍注册、租借场地以及捐款等）及向阁下提供相应服务；</li>" +

          "<li>管理阁下的会员帐户及维持阁下的纪录；</li>" +

          "<li>促进阁下与我们之间的沟通；</li>" +

          "<li>就可能影响阁下的服务更改通知阁下；</li>" +

          "<li>回应及跟进阁下的查询；</li>" +

          "<li>通过阁下感兴趣的节目及推广以提升阁下于西九文化区的体验；</li>" +

          "<li>在获得阁下的明确同意后进行直接促销；</li>" +

          "<li>管理局方内的客户关系；</li>" +

          "<li>根据阁下的兴趣喜好，在有关支持局方的途径上与阁下作适当沟通；</li>" +

          "<li>进行及促进促销活动、节目、抽奖或奖品兑换；</li>" +

          "<li>根据阁下的习惯、体验、兴趣及喜好, 在我们的网站、手机应用程式、社交媒体平台及其他平台（该些网站、手机应用程式及平台于下文均称为「我们的平台」）上定制及发送内容、广告、通知及其他信息；</li>" +

          "<li>管理、维护及改进我们的平台；</li>" +

          "<li>进行统计数据分析、研究、问卷调查、确保服务质素、行为分析及检阅；及</li>" +

          "<li>其他与以上任何一项直接有关的目的。</li>" +

          "</ul><p>我们可能会从不同渠道收集及综合／处理阁下的资料，例如线上渠道（网站、手机应用程式、社交媒体平台等）、离线渠道（申请表格等）、或有关阁下的公开资料。我们会用这些资料帮助提升阁下的体验，以及就阁下可能感兴趣的活动及推广与阁下沟通。</p>" +

          "<p>&nbsp;</p>" +

          "<p><strong>个人资料的使用</strong></p>" +

          "<p>局方内会使用及共用所有收集到的个人资料作以上列出的目的。我们绝对不会向局方以外的机构出售或出租阁下的资料。我们可能会将阁下的个人资料转移予我们的服务供应商（例如资讯科技承办商、云端服务提供者、活动代理及机密文件处置服务代理等），以便他们代表我们提供服务。我们亦可能会跟合办活动的合作伙伴或提供商品及服务给阁下或处理阁下服务要求的服务供应商共用阁下的个人资料。我们也可能需要转移阁下的个人资料至香港特别行政区境外作所需的处理及储存。在与任何第三方合作伙伴（例如第三方网上平台及社交媒体平台等）共用个人资料用作直接促销目的之前，我们会事先征求阁下的同意。我们要求所有服务供应商尊重阁下个人资料的保安，以及遵守《个人资料（私隐）条例》（香港特别行政区法例第486章）（「条例」）及其他适用的个人资料相关法例。我们不允许我们的服务供应商出于其本身的目的使用阁下的个人资料，并只会允许他们为特定的目的及根据我们的指示处理阁下的个人资料。</p>" +

          "<p>&nbsp;</p>" +

          "<p><strong>位置资料</strong></p>" +

          "<p>我们使用「位置资料」部分中所述的位置数据来改善应用程式的结果，并用于下述目的。<br>" +

          "&nbsp;<br>" +

          "WestK 应用程式的使用者：如果阁下已启用设备的位置服务，我们可能会在阁下打开应用程式时收集和使用阁下的起始位置资讯。如果阁下不允许设备的位置服务，我们只会收集阁下手动搜索的起点和终点。当阁下在 WestK 应用程式中共享阁下的位置时，我们会收集阁下全程的位置资讯。我们使用这些数据来提供导航支援，例如提供到达目的地的路线。</p>" +

          "<p>&nbsp;</p>" +

          "<p><strong>查阅或改正资料的要求</strong></p>" +

          "<p>阁下有权要求查阅及改正局方持有关于阁下的个人资料。该要求应以书面形式透过电邮（<a target='_blank' href='mailto:privacy@wkcda.hk'>privacy@wkcda.hk</a>）或邮寄／亲身至「香港九龙西九文化区柯士甸道西8号西九文化区管理局大楼9楼」向「资料保障主任」提交。就我们的私隐政策详情，阁下可以通过&nbsp;<a target='_blank' href='https://www.westk.hk/privacy'>https://www.westk.hk/privacy</a>&nbsp;参考我们的私隐政策声明。</p>" +

          "<p>&nbsp;</p>" +

          "<p><strong>在直接促销中使用资料</strong></p>" +

          "<p>我们有意使用阁下的个人资料及／或与局方内其他公司及我们的合作伙伴（包括第三方网上平台及社交媒体平台）共用阁下的个人资料作直接促销用途，但除非我们得到阁下同意（包括表示不反对该使用及／或共用），否则我们不会如此使用及／或共用阁下的个人资料。直接促销信息可能采取邮件、电子邮件、短信、针对性的网上广告、通过我们的手机应用程式送出的通知、推送通知、即时通讯等形式。该些直接促销信息可与局方的产品、活动、节目及服务有关（包括第三方赞助及／或局方与第三方联合举办的, 以及在西九文化区内提供或进行的产品、活动、节目及服务）（「<strong>直接促销信息</strong>」）。直接促销信息的例子包括通讯、会员礼遇、商店／商品推广、活动邀请、捐款邀请等。这些直接促销信息可由局方及／或第三方代表我们发出（例如第三方网上平台及社交媒体平台）。在收集阁下的个人资料时，请阁下在相关的线上或线下表格中表明阁下同意或不反对该使用及／或共用。</p>" +

          "<p>" +

          "如果阁下不希望收到以上所提及的直接促销信息，阁下可以免费随时选择拒收直接促销信息，方法如下：</p>" +

          "<ul><li>点击在我们发出的电子邮件底部的「取消订阅」链接；</li>" +

          "<li>直接电邮至<a href='mailto:unsubscribe@wkca.hk'>unsubscribe@wkcda.hk</a>；或</li>" +

          "<li>邮寄至「香港九龙西九文化区柯士甸道西8号西九文化区管理局大楼9楼」联络我们的「资料保障主任」。</li>" +

          "</ul><p>如果阁下不希望收到有关筹款活动的信息（包括捐款推广及／或局方的慈善或非牟利活动的捐款），阁下可以免费随时选择拒收筹款活动信息，只需将阁下的指示电邮到：<a target='_blank' href='mailto:development@wkcda.hk'>development@wkcda.hk</a>。</p>" +

          "<p>&nbsp;</p>" +

          "<p><strong>语言版本</strong></p>" +

          "<p>若本声明的英文版本与中文版本存在差异，以英文版本为准。</p>" +

          "" +

          " </div>" +

          " </div>",


        title: "收集个人资料声明",
        CollectionOfYourPersonalData_title: "有关收集个人资料",
        CollectionOfYourPersonalData_text:
          "为提供优质客户体验及服务，西九文化区管理局（管理局）及其管辖下机构，包括西九文化区基金会有限公司（以下简称“基金会”）（统称为“局方”或“我们”）或有需要收集阁下的个人资料。请注意，阁下必须在带有星号的空间内填充个人资料。若无法提供资料，局方可能无法提供相关资讯及/或阁下所要求关于捐款的服务，或处理捐款。",

        PurposesOfPersonalDataCollectionAndUsage_title:
          "个人资料的使用和收集目的",
        PurposesOfPersonalDataCollectionAndUsage_line_1:
          "局方将会使用阁下的个人资料利用以下用途：",
        PurposesOfPersonalDataCollectionAndUsage_point_1:
          "以专业和尊重的方式更新你的鸣谢资料，处理捐款，以及通知阁下捐款所带来的影响；",
        PurposesOfPersonalDataCollectionAndUsage_point_2:
          "处理你的服务要求（例如捐款，税项收据，捐款鸣谢，捐款确认，活动登记，电子通讯订阅等），并为你提供服务",
        PurposesOfPersonalDataCollectionAndUsage_point_3:
          "协助阁下与局方以及其管辖下机构的沟通，以处理阁下的服务要求",
        PurposesOfPersonalDataCollectionAndUsage_point_4:
          "替阁下安排体验最适合你个人喜好的西九文化区活动及推广；",
        PurposesOfPersonalDataCollectionAndUsage_point_5:
          "通知阁下有关服务的更改；",
        PurposesOfPersonalDataCollectionAndUsage_point_6:
          "回应及跟进阁下的查询",
        PurposesOfPersonalDataCollectionAndUsage_point_7:
          "进行统计数据分析，研究，问卷调查，确保服务质素及替代；以及",

        PurposesOfPersonalDataCollectionAndUsage_line_2:
          "若阁下同意直接促销： ",
        PurposesOfPersonalDataCollectionAndUsage_point_8:
          "将联络阁下以提供适当的西九文化区活动，服务，推广，优惠资讯和拓展资讯（包括筹款活动和赞助）；",
        PurposesOfPersonalDataCollectionAndUsage_point_9:
          "根据阁下的兴趣喜好，在有关支持局方或经济上支持局方的途径上与阁下保持适当的联系；以及",
        PurposesOfPersonalDataCollectionAndUsage_point_10:
          "其他与以上有关的目的。",

        PurposesOfPersonalDataCollectionAndUsage_line_3:
          "我们将阁下从不同渠道提供给我们的资料（在线渠道例如：网站/手机应用程序；离线渠道例如：申请表格或有关阁下的公开资料）整合，从而替阁下安排最适合你个人喜好的体验，以及就你可能有兴趣的活动和推广联系阁下。",

        TransferOfPersonalData_title: "个人资料的转移",
        TransferOfPersonalData_line_1:
          "我们绝对不会出售，出租或将阁下的个人资料与局方以外的机构交换。在将阁下的个人资料交给第三方前，我们必定会先得到您的同意。为了代表局方提供服务，某些局方的服务供应商将能够查阅您的个人资料。 （私隐）条例》（香港特别行政区法例第486章）。服务供应商需要遵守局方特定的要求和指示，局方才会允许他们就指定的目的处理阁下的个人资料。商为了其本身目的使用阁下的个人资料。",

        TransferOfPersonalDataOutsideHongKong_title:
          "个人资料的转移（香港以外）",
        TransferOfPersonalDataOutsideHongKong_text_1:
          "收集的个人资料有可能位在香港境内或境外，阁下的资料可能会过境转移至香港以外的地方以作相关处理或储存。",

        PersonalDataSecurityAndRetentionOfData_title: "个人资料的保安及保存",
        PersonalDataSecurityAndRetentionOfData_text_1:
          "根据《个人资料（私隐）条例》，我们不会保留阁下的个人资料超过所需的时间，并会遵守香港特别行政区一切有关保存个人资料的法例及监管规定。阁下经线上申请表提交之资料将会以加密方式发送给局方。阁下保存在局方的个人资料只能由局方授权的员工或安排查阅或接触。",

        Personaldatasecurityandretentionofdatatitle: "要求查阅或改正资料",
        Personaldatasecurityandretentionofdatatext_1:
          '阁下有权要求查阅或改正所有由局方持有关于你的个人资料。若有需要，请以书面形式透过电子邮件（<a href="mailto:privacy@wkcda.hk">privacy@wkcda.hk</a>）或邮寄致「香港数码港道100号数码港3座详情请查询我们的私隐政策 <a href="https://www.westkowloon.hk/privacy">https://www.westkowloon.hk/privacy</a>。「香港九龙西九文化区柯士甸道西8号西九文化区管理局大楼9楼西九文化区管理局」”联络我们的“资料保障主任”。',

        DataAccessAndCorrectionRequeststitle: "要求查阅或改正资料",
        DataAccessAndCorrectionRequeststext_1:
          '阁下有权要求查阅或改正所有由局方持有关于你的个人资料。若有需要，请以书面形式透过电子邮件（<a href="mailto:privacy@wkcda.hk">privacy@wkcda.hk</a>）或邮寄致「香港数码港道100号数码港3座详情请查询我们的私隐政策 <a href="https://www.westkowloon.hk/privacy">https://www.westkowloon.hk/privacy</a>。「香港九龙西九文化区柯士甸道西8号西九文化区管理局大楼9楼西九文化区管理局」”联络我们的“资料保障主任”。',

        UseOfDataInDirectMarketing_title: "在直接促销中使用资料",
        UseOfDataInDirectMarketing_text_1:
          "我们有意将阁下的个人资料作直接促销用途，但除非得到阁下同意（包括表示不反对），否则我们不可在直接促销中使用阁下的资料。",
        UseOfDataInDirectMarketing_text_2:
          "我们可能会使用阁下的姓名，联络资料（例如电子邮件地址），偏好和兴趣，行为资料及交易模式，提供给你西九文化区及/或局方内最符合阁下兴趣的拓展资讯，慈善项目，活动，服务，宣传和特别优惠，或支持我们的途径。若阁下不同意有关使用，请于捐款表格内部「声明及同意书」下剔选相关空格。",

        UseOfDataInDirectMarketing_text_3:
          "如果阁下不希望接收到以上所提及的直接促销信息，您可以免费随时选择拒收直接促销信息，方法如下：",
        UseOfDataInDirectMarketing_point_1:
          "点击在局方发出的电子邮件底部的“取消订阅”链接；",
        UseOfDataInDirectMarketing_point_2:
          '直接电邮至 <a href="mailto:unsubscribe@wkcda.hk">unsubscribe@wkcda.hk</a>; 或 ',
        UseOfDataInDirectMarketing_point_3:
          "邮寄至「香港九龙西九文化区柯士甸道西8号西九文化区管理局大楼9楼西九文化区管理局」联络我们的「资料保障主任」",

        UseOfDataInDirectMarketing_text_4:
          '如果阁下不希望接收到有关筹款活动的消息（包括捐赠的优惠或参与慈善或非牟利活动），您可以免费随时选择拒收筹款活动消息，只需将您的指示语音到：<a href="mailto:development@wkcda.hk">development@wkcda.hk</a>。. ',

        LanguageVersions_title: "不同语言版本",
        LanguageVersions_line_1:
          "若本声明的中文版本与英文版本存在差异，以英文版本为准。",
        picsLatestUpdateDate: "01/03/2021",
      },
      form: {
        personalInfo: "个人资料",
        mustInput: "下列有 * 为必须填写之栏目",
        title: "称谓*",
        firstName: "名*",
        lastName: "姓*",
        taxDeductibleNote: "以上之名字将会用於本基金会之捐款收据上",
        overrideWestkowloonAccounts:
          "我同意以上述最新的资料取替本人之前所提供的个人资料（包括姓名和电话）",
        phone: "电话号码*",
        phoneLengthRequired: "电话号码必须{{length}}位数字或以上",
        areaCode: "地区号码",
        venuesHeader: "你对我们以下那个场地有兴趣",
        languagePref: "语言选择*",
        receipt: "收据",
        receiptNote:
          "我们稍后将会把电子收据发予你，请确保以上所输入之电邮地址正确无误。如阁下需要列印版收据，请在以下栏目加上「✓」号。列印本收据将于一个月内发出。",
        receiptNote_pa: "我們稍後將會把電子收據發予你。",
        receiptCheckboxNote:
          "请在此栏目加上「✓」号，并在下方提供你的邮寄地址。",
        receiptCheckboxNote_pa:
          "如阁下需要收据正本，请划上「✓」号 。 收据正本将於一个月内发出。",
        PICHeader: "个人资料收集声明",
        PICaria: "我在此声明",
        PICStatement1:
          "我在此声明我已仔细阅读相关资料，并完全明白及同意受西九文化区基金会的",
        termsAndConditions: "注意事项",
        and: "和",
        PICS: "个人资料收集声明",
        PICStatement2:
          "所约束。同时，我允许西九文化区基金会使用本人之个人资料，并明白本人有权按照个人资料收集声明条例，要求存取及更改我的个人资料。",
        dataUseMarketing: "使用资料作直接促销",
        marketingPurpose:
          "我们将使用你的名字、联络资料(如电子邮件)、个人喜好、兴趣、档案信息、交易资料，并根据你的兴趣，为你提供在西九文化区内举行相关之活动、服务、推广以及特别折扣的资讯，以及支持本基金会的方法。",
        eNewsNotification:
          "*如你早前已订阅西九电子通讯,可随时透过附设在任何一期电子通讯底部的连结取消订阅。",
        checkboxReceiveInfo:
          "我希望收到有关由西九文化区举办或于文化区内举行的活动资料。",
        checkboxReceiveDevUpdates: "我希望收到关于西九发展的最新拓展资讯。",
        revise: "上一页",
        addressLine1: "居住地址 1",
        addressLine2: "居住地址 2",
        roomFloorBlock: "室／楼层／座",
        buildingEstateStreet: "大厦／屋苑名称／街道",
        region: "地区",
        district: "区域",
        area: "各区",
        hongKong: "香港",
        termsAndConditionsURL:
          "https://www.westkowloon.hk/sc/footer/privacy-policy#pps",
        PICSURL: "https://www.westkowloon.hk/sc/footer/privacy-policy#pps",
      },
      venue: {
        "WKCDA General": "西九文化区一般慈善项目", // '西九龙文化区一般',
        artPark: "艺术公园",
        palaceMuseum: "香港故宫文化博物馆",
        mPlus: "M+",
        xiquCentre: "戏曲中心",
        lyricThreatre: "演艺综合剧场",
        freespace: "自由空间",
        "West Kowloon Cultural District in General": "西九文化区一般慈善项目", // '西九龙文化区一般',
        "Art Park": "艺术公园",
        "Hong Kong Palace Museum": "香港故宫文化博物馆",
        "M+": "M+",
        "Xiqu Centre": "戏曲中心",
        "Lyric Theatre Complex": "演艺综合剧场",
        Freespace: "自由空间",
      },
      filter: {
        showDonorsNearby: "显示附近捐赠者",
        tree: "助养树木",
        bench: "石椅留芳名",
        seat: "一人一石",
        price: "价格",
        woodland: "内园",
        seaside: "海傍",
        // "urbanForest": "城市森林",
        // "orchard": "果园",
        reset: "重置过滤器",
      },
      success: {
        title_thankyou: "衷心感谢！",
        title_fail: "捐款程序尚未完成",
        fail: "抱歉阁下的捐款未能完成，请与您的银行联络，或再核实有关资料是否正确。",
        failLine2:
          "你的捐款将为西九文化区带来不一样的改变，殷切期待阁下的支持！",
        failLine3: "",
        failLine4:
          "如有任何查询，欢迎电邮至<a href='mailto:donation@wkcda.hk'>donation@wkcda.hk</a>与我们联络。",

        thankYou: "感谢阁下对西九文化区的慷慨支持！",
        thankYou2: "待捐款确认後，我们将於一个月内发出捐款收据。",
        thankYou3:
          "您的支持为西九文化区注入新力量，让我们可持续多元艺术制作，使更多人能够接触及欣赏不同文化艺术展览及表演活动。",
        thankYou4:
          "阁下对捐款事宜如有任何查询，欢迎电邮至<a href='mailto:donation@wkcda.hk'>donation@wkcda.hk</a>与我们联络。",

        donationReceived:
          "您的捐款已收到好评，并且在审核过程中捕获了以下详细信息：",
        amount: "您的捐款金额：{{price}}",
        donationAcknowledgement: "您的捐赠确认将显示为：{{acknowledgement}}",
        receiptName: "正式收据上的姓名：{{name}}",
        ref: "捐款编号：{{donationId}}",
        type: "捐赠类型：{{projectType}}",
        assetName: "资产名称： {{assetName}}",
        message: "信息：{{message}}",
        taxReceipt:
          "在30天之内确认捐款后，便会为您准备一张税收收据，并将与您共享相关的确认宣传材料。",
        contactYou:
          "同时，我们可能会与您联系，以提出建议的命名（如果需要）或其他相关问题。",
        reachUsAt: `代表西九龙的每个人，来自本地和国际艺术界的艺术才华以及来自香港和世界各地的数百万艺术爱好者-谢谢！如果您对捐款有任何疑问，请通过donation@wkcda.hk与我们联系。 `,
        donateAgain: "再次捐款",
        backWestKowloon: "返回基金会主页",
        donateAgainURLG: "https://support-uat.westkowloon.hk/sc/donate-now-cn/",
        donateAgainURLA: "https://support-uat.westkowloon.hk/donation/?lng=hk",
        backWestKowloonURL: "https://support-uat.westkowloon.hk/sc/home-cn/",
      },
      cookies: {
        cookies_experience: "我们在本网站上使用Cookies来增强您的用户体验。",
        more_info: "更多资讯",
        agree: "我同意",
      },
      notFound: {
        notExist: "该页面不存在",
        backHome: "返回主页",
        uri: "https://support-uat.westkowloon.hk/sc/home-cn/",
      },
      "Hong Kong SAR": "香港特别行政区",
      China: "中国",
      "Macau SAR": "澳门特区",
      Afghanistan: "阿富汗",
      Albania: "阿尔巴尼亚",
      Algeria: "阿尔及利亚",
      "American Samoa": "美属萨摩亚",
      Andorra: "安道尔",
      Angola: "安哥拉",
      Anguilla: "安圭拉",
      Antarctica: "南极洲",
      "Antigua and Barbuda": "安提瓜和巴布达",
      Argentina: "阿根廷",
      Armenia: "亚美尼亚",
      Aruba: "阿鲁巴",
      Australia: "澳大利亚",
      Austria: "奥地利",
      Azerbaijan: "阿塞拜疆",
      Bahamas: "巴哈马",
      Bahrain: "巴林",
      Bangladesh: "孟加拉国",
      Barbados: "巴巴多斯",
      Belarus: "白俄罗斯",
      Belgium: "比利时",
      Belize: "伯利兹",
      Benin: "贝寧",
      Bermuda: "百慕大",
      Bhutan: "不丹",
      Bolivia: "玻利维亚",
      "Bonaire, Sint Eustatius and Saba": "博内尔岛,圣尤斯特歇斯和萨巴岛",
      "Bosnia and Herzegovina": "波斯尼亚和黑塞哥维那",
      Botswana: "博茨瓦纳",
      "Bouvet Island": "布威岛",
      Brazil: "巴西",
      "British Indian Ocean Territory": "英属印度洋领地",
      Brunei: "文莱",
      Bulgaria: "保加利亚",
      "Burkina Faso": "布基纳法索",
      Burundi: "布隆迪",
      Cambodia: "柬埔寨",
      Cameroon: "喀麦隆",
      Canada: "加拿大",
      "Cape Verde": "佛得角",
      "Cayman Islands": "开曼群岛",
      "Central African Republic": "中非共和国",
      Chad: "乍得",
      Chile: "智利",
      "Christmas Island": "圣诞岛",
      "Cocos (Keeling) Islands": "科科斯（基林）群岛",
      Colombia: "哥伦比亚",
      Comoros: "科摩罗",
      "Congo, Democratic Republic of the": "刚果民主共和国",
      "Congo, Republic of the": "刚果共和国",
      "Cook Islands": "库克群岛",
      "Costa Rica": "哥斯达黎加",
      "Cote d'Ivoire": "科特迪瓦",
      Croatia: "克罗地亚",
      Cuba: "古巴",
      Curacao: "库拉索",
      Cyprus: "塞浦路斯",
      "Czech Republic": "捷克共和国",
      Denmark: "丹麦",
      Djibouti: "吉布提",
      Dominica: "多米尼加",
      "Dominican Republic": "多明尼加共和国",
      Ecuador: "厄瓜多尔",
      Egypt: "埃及",
      "El Salvador": "萨尔瓦多",
      "Equatorial Guinea": "赤道几内亚",
      Eritrea: "厄立特里亚",
      Estonia: "爱沙尼亚",
      Ethiopia: "埃塞俄比亚",
      "Falkland Islands (Islas Malvinas)": "福克兰群岛（马尔维纳斯岛）",
      "Faroe Islands": "法罗群岛",
      Fiji: "斐济",
      Finland: "芬兰",
      France: "法国",
      "French Guiana": "法属圭亚那",
      "French Polynesia": "法属波利尼西亚",
      "French Southern and Antarctic Lands": "法国南部和南极土地",
      Gabon: "加蓬",
      Gambia: "冈比亚",
      Georgia: "乔治亚州",
      Germany: "德国",
      Ghana: "加纳",
      Gibraltar: "直布罗陀",
      Greece: "希腊",
      Greenland: "格陵兰",
      Grenada: "格林纳达",
      Guadeloupe: "瓜德罗普岛",
      Guam: "关岛",
      Guatemala: "危地马拉",
      Guernsey: "根西岛",
      Guinea: "几内亚",
      "Guinea-Bissau": "几内亚比绍",
      Guyana: "圭亚那",
      Haiti: "海地",
      "Heard Island and McDonald Islands": "希尔德岛和麦当劳群岛",
      "Holy See (Vatican City)": "罗马教廷（梵蒂冈）",
      Honduras: "洪都拉斯",
      Hungary: "匈牙利",
      Iceland: "冰岛",
      India: "印度",
      Indonesia: "印度尼西亚",
      Iran: "伊朗",
      Iraq: "伊拉克",
      Ireland: "爱尔兰",
      "Isle of Man": "人岛",
      Israel: "以色列",
      Italy: "意大利",
      Jamaica: "牙买加",
      Japan: "日本",
      Jersey: "泽西",
      Jordan: "约旦",
      Kazakhstan: "哈萨克斯坦",
      Kenya: "肯尼亚",
      Kiribati: "基里巴斯",
      "Korea, North": "北朝鲜",
      "Korea, South": "南柯尔",
      Kosovo: "科索沃",
      Kuwait: "科威特",
      Kyrgyzstan: "吉尔吉斯斯坦",
      Laos: "老挝",
      Latvia: "拉脱维亚",
      Lebanon: "黎巴嫩",
      Lesotho: "莱索托",
      Liberia: "利比里亚",
      Libya: "利比亚",
      Liechtenstein: "列支敦士登",
      Lithuania: "立陶宛",
      Luxembourg: "卢森堡",
      Macedonia: "马其顿",
      Madagascar: "马达加斯加",
      Malawi: "马拉维",
      Malaysia: "马来西亚",
      Maldives: "马尔代夫",
      Mali: "马里",
      Malta: "马耳他",
      "Marshall Islands": "马绍尔群岛",
      Martinique: "马提尼克岛",
      Mauritania: "毛里塔尼亚",
      Mauritius: "毛里求斯",
      Mayotte: "马约特岛",
      Mexico: "墨西哥",
      Micronesia: "密克罗尼西亚",
      Moldova: "摩尔多瓦",
      Monaco: "摩纳哥",
      Mongolia: "蒙古",
      Montenegro: "黑山",
      Montserrat: "蒙特塞拉特",
      Morocco: "摩洛哥",
      Mozambique: "莫桑比克",
      Myanmar: "缅甸",
      Namibia: "纳米比亚",
      Nauru: "瑙鲁",
      Nepal: "尼泊尔",
      Netherlands: "荷兰",
      "New Caledonia": "新喀裡多尼亚",
      "New Zealand": "新西兰",
      Nicaragua: "尼加拉瓜",
      Niger: "尼日尔",
      Nigeria: "尼日利亚",
      Niue: "纽埃",
      "Norfolk Island": "诺福克岛",
      "Northern Mariana Islands": "北马里亚纳群岛",
      Norway: "挪威",
      Oman: "阿曼",
      Pakistan: "巴基斯坦",
      Palau: "帕劳",
      Panama: "巴拿马",
      "Papua New Guinea": "巴布亚新几内亚",
      Paraguay: "巴拉圭",
      Peru: "秘鲁",
      Philippines: "菲律宾",
      "Pitcairn Islands": "皮特凯恩群岛",
      Poland: "波兰",
      Portugal: "葡萄牙",
      "Puerto Rico": "波多黎各",
      Qatar: "卡塔尔",
      Reunion: "团圆",
      Romania: "罗马尼亚",
      Russia: "俄国",
      Rwanda: "卢旺达",
      "Saint Barthelemy": "圣巴泰勒米",
      "Saint Helena, Ascension, and Tristan da Cunha":
        "圣海伦娜,升天和特里斯坦�达库尼亚",
      "Saint Kitts and Nevis": "圣基茨和尼维斯",
      "Saint Lucia": "圣卢西亚",
      "Saint Martin": "圣马丁",
      "Saint Pierre and Miquelon": "圣皮埃尔和密克隆群岛",
      "Saint Vincent and the Grenadines": "圣文森特和格林纳丁斯",
      Samoa: "萨摩亚",
      "San Marino": "圣马力诺",
      "Sao Tome and Principe": "圣多美和普林西比",
      "Saudi Arabia": "沙特阿拉伯",
      Senegal: "塞内加尔",
      Serbia: "塞尔维亚",
      Seychelles: "塞舌尔",
      "Sierra Leone": "塞拉利昂",
      Singapore: "新加坡",
      "Sint Maarten": "圣马丁",
      Slovakia: "斯洛伐克",
      Slovenia: "斯洛文尼亚",
      "Solomon Islands": "所罗门群岛",
      Somalia: "索马里",
      "South Africa": "南非",
      "South Georgia and the Islands": "南乔治亚岛",
      "South Sudan": "南苏丹",
      Spain: "西班牙",
      "Sri Lanka": "斯里兰卡",
      "State of Palestine": "巴勒斯坦国",
      Sudan: "苏丹",
      Suriname: "苏里南",
      Svalbard: "斯瓦尔巴群岛",
      Swaziland: "斯威士兰",
      Sweden: "瑞典",
      Switzerland: "瑞士",
      Syria: "叙利亚",
      Taiwan: "台湾",
      Tajikistan: "塔吉克斯坦",
      Tanzania: "坦桑尼亚",
      Thailand: "泰国",
      Timor: "东帝汶",
      Togo: "多哥",
      Tokelau: "托克劳",
      Tonga: "汤加",
      "Trinidad and Tobago": "特立尼达和多巴哥",
      Tunisia: "突尼斯",
      Turkey: "火鸡",
      Turkmenistan: "土库曼斯坦",
      "Turks and Caicos Islands": "特克斯和凯科斯群岛",
      Tuvalu: "图瓦卢",
      Uganda: "乌干达",
      Ukraine: "乌克兰",
      "United Arab Emirates": "阿拉伯联合酋长国",
      "United Kingdom": "英国",
      "United States": "美国",
      "United States Minor Outlying Islands": "美国本土外小岛屿",
      Uruguay: "乌拉圭",
      Uzbekistan: "乌兹别克斯坦",
      Vanuatu: "瓦努阿图",
      Venezuela: "委内瑞拉",
      Vietnam: "越南",
      "Virgin Islands (British)": "维尔京群岛（英国）",
      "Virgin Islands (U.S.)": "维京群岛（美国）",
      "Virgin Islands (US.)": "维京群岛（美国）",
      "Wallis and Futuna": "沃利斯和富图纳群岛",
      "Western Sahara": "撒哈拉沙漠西部",
      Yemen: "也门",
      Zambia: "赞比亚",
      Zimbabwe: "津巴布韦",
      "儻and Islands": "奥兰群岛",
      "Hong Kong Island": "香港岛",
      Kowloon: "九龙",
      "New Territories": "新界",
      "Central and Western": "香港中西",
      Eastern: "香港东",
      Southern: "香港南",
      "Wan Chai": "湾仔",
      "Kowloon City": "九龙城",
      "Kwun Tong": "观塘",
      "Sham Shui Po": "深水埗",
      "Wong Tai Sin": "黄大仙",
      "Yau Tsim Mong": "油尖旺",
      Islands: "岛屿",
      "Kwai Tsing": "葵青",
      North: "北区",
      "Sai Kung": "西贡",
      "Sha Tin": "沙田",
      "Tai Po": "大埔",
      "Tsuen Wan": "荃湾",
      "Tuen Mun": "屯门",
      "Yuen Long": "元朗",
      "Kennedy Town": " 坚尼地城",
      "Shek Tong Tsui": "石塘咀",
      "Sai Ying Pun": "西营盘",
      "Sheung Wan": "上环",
      Central: "中央",
      Admiralty: "金鐘",
      "Mid-levels": "半山区",
      Peak: "山顶",
      "Tin Hau": "天后",
      "Braemar Hill": "宝马山",
      "North Point": "北角",
      "Quarry Bay": "鰂鱼涌",
      "Sai Wan Ho": "西湾河",
      "Shau Kei Wan": "筲箕湾",
      "Chai Wan": "柴湾",
      "Siu Sai Wan": "小西湾",
      "Pok Fu Lam": "薄扶林",
      Aberdeen: "香港仔",
      "Ap Lei Chau": "鸭脷洲",
      "Wong Chuk Hang": "黄竹坑",
      "Shouson Hill": "寿臣山",
      "Repulse Bay": "浅水湾",
      "Chung Hom Kok": "中坎角",
      Stanley: "赤柱",
      "Tai Tam": "大潭",
      "Shek O": "石澳",
      "Wan Chai": "湾仔",
      "Causeway Bay": "铜锣湾",
      "Happy Valley": "跑马地",
      "Tai Hang": "大坑",
      "So Kon Po": "扫桿埔",
      "Jardine's Lookout": "渣甸山",
      "Hung Hom": "红磡",
      "To Kwa Wan": "土瓜湾",
      "Ma Tau Kok": "马头角",
      "Ma Tau Wai": "马头围",
      "Kai Tak": "啟德",
      "Kowloon City": "九龙城",
      "Ho Man Tin": "何文田",
      "Kowloon Tong": "九龙塘",
      "Beacon Hill": "笔架山",
      "Ping Shek": "平石",
      "Kowloon Bay": "九龙湾",
      "Ngau Tau Kok": "牛头角",
      "Jordan Valley": "佐敦",
      "Kwun Tong": "观塘",
      "Sau Mau Ping": "秀茂坪",
      "Lam Tin": "蓝田",
      "Yau Tong": "油塘",
      "Lei Yue Mun": "鲤鱼门",
      "Mei Foo": "美孚",
      "Lai Chi Kok": "荔枝角",
      "Cheung Sha Wan": "长沙湾",
      "Sham Shui Po": "深水埗",
      "Shek Kip Mei": "石硤尾",
      "Yau Yat Tsuen": "又一村",
      "Tai Wo Ping": "太和坪",
      "Stonecutters Island": "昂船洲",
      "San Po Kong": "新蒲岗",
      "Wong Tai Sin": "黄大仙",
      "Tung Tau": "桐头",
      "Wang Tau Hom": "横头磡",
      "Lok Fu": "乐富",
      "Diamond Hill": "钻石山",
      "Tsz Wan Shan": "慈云山",
      "Ngau Chi Wan": "牛池湾",
      "Tsim Sha Tsui": "尖沙咀",
      "Yau Ma Tei": "油麻地",
      "West Kowloon Reclamation": "西九龙填海区",
      "King's Park": "京士柏",
      "Mong Kok": "旺角",
      "Tai Kok Tsui": "大角咀",
      "Cheung Chau": "长洲",
      "Peng Chau": "彭州",
      "Lantau Island (incl. Tung Chung)": "大屿山（包括东涌）",
      "Lantau Island (incl Tung Chung)": "大屿山（包括东涌）",
      "Lamma Island": "南丫岛",
      "Kwai Chung": "葵涌",
      "Tsing Yi": "青衣",
      Fanling: "粉岭",
      "Luen Wo Hui": "联和会",
      "Sheung Shui": "上水",
      "Shek Wu Hui": "石湖墟",
      "Sha Tau Kok": "沙头角",
      "Luk Keng": "陆恭",
      "Wu Kau Tang": "乌蛟腾",
      "Clear Water Bay": "清水湾",
      "Sai Kung": "西贡",
      "Tai Mong Tsai": "大孟仔",
      "Tseung Kwan O": "将军澳",
      "Hang Hau": "坑口",
      "Tiu Keng Leng": "调景岭",
      "Ma Yau Tong": "马友堂",
      "Tai Wai": "大围",
      "Sha Tin": "沙田",
      "Fo Tan": "火炭",
      "Ma Liu Shui": "马六水",
      "Wu Kai Sha": "乌溪沙",
      "Ma On Shan": "马鞍山",
      "Tai Po Market": "大埔墟",
      "Tai Po": "大埔",
      "Tai Po Kau": "大埔滘",
      "Tai Mei Tuk": "大尾篤",
      "Shuen Wan": "信湾",
      "Cheung Muk Tau": "樟木头",
      "Kei Ling Ha": "企岭下",
      "Tsuen Wan": "荃湾",
      "Lei Muk Shue": "李木树",
      "Ting Kau": "汀九",
      "Sham Tseng": "深井",
      "Tsing Lung Tau": "青龙头",
      "Ma Wan": "马湾",
      "Sunny Bay": "阳光湾",
      "Tai Lam Chung": "大欖涌",
      "So Kwun Wat": "扫管笏",
      "Tuen Mun": "屯门",
      "Lam Tei": "蓝地",
      "Hung Shui Kiu": "洪水桥",
      "Ha Tsuen": "下村",
      "Lau Fau Shan": "琉浮山",
      "Tin Shui Wai": "天水围",
      "Yuen Long": "元朗",
      "San Tin": "新田",
      "Lok Ma Chau": "落马洲",
      "Kam Tin": "锦田",
      "Shek Kong": "石岗",
      "Pat Heung": "八乡",
    },
  },
};
